import { AssetAttachmentService } from './../../data-services/asset-attachment.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { HttpErrorResponse } from '@angular/common/http';
import {
    AfterViewChecked,
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import difference from 'lodash.difference';
import { DeviceDetectorService } from 'ngx-device-detector';
import pluralize from 'pluralize';
import { Paginator } from 'primeng/paginator';
import { MultiSelect } from 'primeng/multiselect';
import { Table } from 'primeng/table';
import { Observable, of as observableOf, Subscription } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { LIMIT } from '../../../../../shared/constants/asset-limit.constant';
import { AssetIndexTypes } from '../../../../../shared/enums/asset-index-types.enum';
import { RequestStatus, RequestStatusOptions } from '../../../../../shared/enums/request-status.enum';
import { RequestTypes } from '../../../../../shared/enums/request-types.enum';
import { TransactionTypes } from '../../../../../shared/enums/transaction-types';
import { FAKE_EVENT_FIELD, FAKE_STORAGE_BOX_BARCODE_FIELD } from '../../../../../shared/fields/fake-fields';
import { FIELD_TYPES } from '../../../../../shared/fields/field-types';
import { STANDARD_FIELDS, StandardField, DEFAULT_FREE_FIELDS_NAME } from '../../../../../shared/fields/standard-fields';
import { Entities } from '../../../../../shared/types';
import { ColumnFilterOptions } from '../../../../../shared/types/column-filter-options';
import { ASSET_MODAL_TYPE } from '../../../assets/asset-modal/asset-modal.component';
import { FranchiseAssetViews } from '../../../assets/franchise-asset-index/franchise-asset-index.component';
import { MergeAssetsModalComponent, MergeAssetsModalData } from '../../../assets/merge-assets-modal/merge-assets-modal.component';
import * as fromRoot from '../../../core/store';
import * as assetModalActions from '../../../core/store/asset-modal/asset-modal.actions';
import * as assetActions from '../../../core/store/assets/asset.actions';
import { AssetTypes } from '../../../core/store/assets/asset.model';
import * as eventActions from '../../../core/store/events/event.actions';
import * as fieldActions from '../../../core/store/fields/field.actions';
import { getBulkFields } from '../../../core/store/fields/field.service';
import * as layoutActions from '../../../core/store/layout/layout.actions';
import {
    Asset,
    AssetEvent,
    Character,
    CustomStudioFieldName,
    Department,
    DepartmentField,
    Disposition,
    Division,
    Event,
    ExcludedDisposition,
    Field,
    Franchise,
    Group,
    Location,
    Photo,
    Project,
    ProjectCurrency,
    Request,
    Set as SetModel,
    Status,
    SubDepartment,
    SubGroup,
    Transaction,
    User
} from '../../../core/store/models';
import * as reportActions from '../../../core/store/reports/report.actions';
import * as requestAssetActions from '../../../core/store/request-assets/request-asset.actions';
import { characterSelectors, fieldSelectors, projectCurrencySelectors, setSelectors, subDepartmentSelectors } from '../../../core/store/selectors';
import { ActionStatus, SortObject, TableFilterObject } from '../../../core/store/types';
import { TableTypes } from '../../../core/store/types';
import { buildPDropdownOptions, makeCharOrSetDropdown, makeProjectCurrencyDropdown } from '../../../core/store/utils';
import { AddToRequestModalComponent, AddToRequestModalData } from '../../../shared/components/add-to-request-modal/add-to-request-modal.component';
import { BarcodeModalComponent } from '../../../shared/components/barcode-input/barcode-modal.component';
import { BULK_MODAL_ACTIONS, BulkModalComponent, BulkModalData } from '../../../shared/components/bulk-modal/bulk-modal.component';
import { ConfirmModalComponent, ConfirmModalData } from '../../../shared/components/confirm-modal/confirm-modal.component';
import { InlineEditModalComponent, InlineEditModalData } from '../../../shared/components/inline-edit-modal/inline-edit-modal.component';
import { MobileColumnModalComponent, MobileColumnModalData } from '../../../shared/components/mobile-column-modal/mobile-column-modal.component';
import { PDropdownOption } from '../../../shared/interfaces/p-dropdown-options';
import { exportCSV } from '../../../shared/services/csv.service';
import { TransactionFormService } from '../../../transactions/services/transaction-form.service';
import { AssetDataService } from '../../data-services/asset-data.service';
import { AssetModalDataService } from '../../data-services/asset-modal-data.service';
import { BulkMoveModalDataService } from '../../data-services/bulk-move-modal-data.service';
import { ColumnFilterService } from '../../services/column-filter.service';
import { CheckInModalComponent, CheckInModalData } from '../check-in-modal/check-in-modal.component';
import { CheckOutModalComponent, CheckOutModalData } from '../check-out-modal/check-out-modal.component';
import { CreateAssetFromTrxModalComponent, CreateAssetFromTrxModalData } from '../create-asset-from-trx-modal/create-asset-from-trx-modal.component';
import * as transactionActions from './../../../core/store/transactions/transaction.actions';
import { TransactionDataService } from './../../../shared/data-services/transaction-data.service';
import { assetTableDefaultSortObject, hideClearFilter } from './asset-data-table.helpers';
import { TableState } from './asset-data-table.helpers';
import { UpdateFieldModalComponent, UpdateFieldModalData } from '../update-field-modal/update-field-modal.component';
import { AssetLimitModalComponent } from '../../../shared/components/asset-limit-modal/asset-limit-modal.component';
import { FieldVisibility } from '../../../../../shared/enums/field-visibility.enum';

import * as characterActions from '../../../core/store/characters/character.actions';
import * as setActions from '../../../core/store/sets/set.actions';
import { PhotoUploadModalComponent } from '../../../assets/photo-upload-modal/photo-upload-modal.component';
import * as groupTypesActions from "../../../core/store/group-types/group-types.actions";
import { LocalStorageService } from '../../services/local-storage.service';
import { AttachmentUploadModalComponent } from '../attachment-upload-modal/attachment-upload-modal.component';

@Component({
    selector: 'ah-asset-data-table',
    templateUrl: './asset-data-table.component.html',
    styleUrls: ['./asset-data-table.component.scss'],
    providers: [TransactionFormService],
    standalone: false
})
export class AssetDataTableComponent implements OnInit, OnChanges, OnDestroy, AfterViewChecked, AfterViewInit {
    static TOGGLE_EXCLUDED_LABELS = {
        [AssetIndexTypes.Default]: 'Move to Excluded',
        [AssetIndexTypes.Excluded]: 'Move Out of Excluded'
    };

    @Input() isTransactionMatchTable = false;
    @Input() isTransactionMatchReviewTable = false;
    @Input() hideBulkOption = false;
    @Input() hideChooseColumns = false;
    /** Options used for the Choose Column Picker */
    @Input() allFieldOptions?: PDropdownOption[] = [];
    @Input() allGroups$?: Observable<Group[]>;
    @Input() assetDataService: AssetDataService;
    @Input() assetEntities?: Entities<Asset>;
    @Input() assetModalDataService: AssetModalDataService;
    @Input() assets: Asset[] = [];
    @Input() assetCountTotal = 0;
    @Input() assetEventForAssetIds?: { [assetId: number]: AssetEvent };
    @Input() assetTypesShown?: AssetTypes;
    @Input() assetValidLookup?: { [assetId: number]: boolean } = {};
    @Input() bulkModalCharacters$?: Observable<Character[]>;
    @Input() bulkModalSets$?: Observable<SetModel[]>;
    @Input() characters?: Observable<Character[]> = observableOf([]);
    @Input() columnFilterService: ColumnFilterService;
    @Input() currentStudioId: number;
    @Input() currentView?: AssetIndexTypes;
    @Input() departmentList?: Observable<Department[]> = observableOf([]);
    @Input() departments: Department[] = [];
    @Input() dispositions$: Observable<Disposition[]> = observableOf([]);
    @Input() division?: Division;
    @Input() divisionGroups$?: Observable<Group[]> = observableOf([]);
    @Input() notDivisionGroups$?: Observable<Group[]> = observableOf([]);
    @Input() event?: Event;
    @Input() events$?: Observable<Event[]> = observableOf([]);
    @Input() sourceEventId?: number;
    @Input() expandedItems?: { [s: string]: boolean; } = {};
    @Input() excludedDispositions$: Observable<ExcludedDisposition[]> = observableOf([]);
    @Input() fields: Field[] = []; // All fields + fake fields the user has access to
    /** Required for visually updating filters */
    @Input() filters: TableFilterObject = {};
    @Input() finalApproversEnabled? = false;
    @Input() franchise?: Franchise;
    @Input() franchiseGroups$?: Observable<Group[]> = observableOf([]);
    @Input() group: Group;
    @Input() subGroup?: SubGroup;
    @Input() notFranchiseGroups$?: Observable<Group[]> = observableOf([]);
    @Input() locations$: Observable<Location[]>;
    @Input() defaultFilters: TableFilterObject;
    /** Divisions the current user can move Assets to */
    @Input() ownedDivisions?: Division[] = [];
    /** Franchises the current user can move Assets to */
    @Input() ownedFranchises?: Franchise[] = [];
    @Input() projectCurrencies$?: Observable<ProjectCurrency[]> = observableOf([]);
    @Input() projectList?: Observable<Project[]> = observableOf([]);
    @Input() qtyOnHand?: { [assetId: number]: number };
    @Input() request?: Request;
    @Input() requestType?: RequestTypes;
    @Input() selectedDepartmentIdsList?: number[] = [];
    /** Field Ids of the selected columns, used in the Choose Columns picker */
    @Input() selectedFieldOptions: number[] = [];
    @Input() selectedExcludedFieldOptions: number[] = []
    /** Used as the Columns in the p-Table */
    @Input() selectedFields: Field[] = [];
    @Input() selectedProjectCurrencyId?: number;
    @Input() selectedProjectIdsList?: number[] = [];
    @Input() selectedWarehouseIdsList?: number[] = [];
    @Input() selectOptions: ColumnFilterOptions = {};
    @Input() sets?: Observable<SetModel[]> = observableOf([]);
    @Input() showPillColumn? = false;
    @Input() statuses$?: Observable<Status[]> = observableOf([]);
    @Input() subDepartments?: Observable<SubDepartment[]> = observableOf([]);
    @Input() tableType: TableTypes;
    @Input() transactions: Transaction[] = [];
    @Input() transactionTypesShown?: TransactionTypes;
    @Input() updateCharSetOptions?: boolean;
    @Input() user: User;
    @Input() views?;
    @Input() hasBarcodeField = false;
    @Input() indexType?: AssetIndexTypes = AssetIndexTypes.Default;
    @Input() stateKey: string;
    @Input() isDispositionVisible = false;
    @Output() openCreateDialog = new EventEmitter();
    @Output() updateAssetCountForSubGroups? = new EventEmitter();
    @Output() listAssetsAndFilters?: EventEmitter<{ listType?: AssetIndexTypes, listAll?: boolean }> = new EventEmitter();
    @Output() selectProjectCurrency = new EventEmitter();
    @Output() setSelectedAssets? = new EventEmitter();
    @Output() showRequestConflicts = new EventEmitter();
    @Output() filterTableColumns = new EventEmitter();
    @Output() assetUpdated? = new EventEmitter();
    @Output() sortTable = new EventEmitter();
    @Output() pageChanged = new EventEmitter();
    @Output() displayChanged = new EventEmitter();
    @Output() exportAllCsvEvent = new EventEmitter();
    @Output() isAllSelected? = new EventEmitter<boolean>();

    @ViewChild('tt', { static: true }) turboTable: Table;
    @ViewChild('multiSelect') multiSelect: MultiSelect;
    @ViewChild('paginator', { static: false }) paginator: Paginator;

    disableClearFilter: boolean = false;
    approvalsEnabled = false;
    assetTypes = AssetTypes;
    assetIndexTypes = AssetIndexTypes;
    canEdit = false;
    canViewHistorical = true;
    loggedInUserIndicator = true;
    characters$: Observable<Character[]> = observableOf([]);
    characterOptions$: Observable<PDropdownOption[]> = observableOf([]);
    checkboxOptions = [
        { label: 'All', value: 'all' },
        { label: 'True', value: 'true' },
        { label: 'False', value: 'false' },
        { label: 'None', value: 'null' }
    ];
    customFieldNames: CustomStudioFieldName;
    groupId: number;
    subGroupId: number;
    dateFiltersMin: { [canonical_name: string]: Date } = {};
    dateFiltersMax: { [canonical_name: string]: Date } = {};
    dispositionOptions$: Observable<PDropdownOption[]> = observableOf([]);
    expandedItemHTMLElem: Element = null;
    exportToCSVService = exportCSV;
    fieldEntities: { [fieldId: number]: Field } = {}; // All fields + fake fields
    fieldTypes: any = {};
    FranchiseAssetViews = FranchiseAssetViews;
    isApprover = false;
    isDivisionTable = false;
    isEventTable = false;
    isFiltered = false;
    isDivisionGroupTable = false;
    isFranchiseGroupTable = false;
    isStudioGroupTable = false;
    isDivisionSubGroupTable = false;
    isFranchiseSubGroupTable = false;
    isStudioSubGroupTable = false;
    isFranchiseTable = false;
    isLoading = true;
    isRequestTable = false;
    isStudioTable = false;
    tooltip = true;
    /** All assets in the table are selected */
    isAllAssetsSelected = false;
    isTransactionTable = false;
    latestSortObject: any = {};
    assetLimit = LIMIT;
    modalDispositions$: Observable<Disposition[]>;
    mobileOptions = [{ label: 'Choose Columns', command: () => { this.openChooseColumnModal(); } }];
    modalProjectCurrencies$: Observable<ProjectCurrency[]>;
    modalStatuses$: Observable<Status[]>;
    options$: Observable<PDropdownOption[]> = observableOf([]);
    filterValues: { [field: string]: string } = {};
    pluralize = pluralize;
    projectCurrencyOptions$: Observable<PDropdownOption[]> = observableOf([]);
    RequestStatus = RequestStatus;
    requestStatusOptions = RequestStatusOptions;
    RequestTypes = RequestTypes;
    responsive = false;
    rowsPerPage: number;
    /** Whether the sellect all checkbox is checked for each page */
    selectAllCheckedForPage: { [page: number]: boolean } = {};
    selectedAssets?: Set<number> = new Set([]);
    selectedTransactions: Set<number> = new Set([]);
    setOptions$: Observable<PDropdownOption[]> = observableOf([]);
    sets$: Observable<SetModel[]> = observableOf([]);
    standardFields: { [field: string]: StandardField };
    statusOptions$: Observable<PDropdownOption[]> = observableOf([]);
    subDepartments$: Observable<SubDepartment[]>;
    subDepartmentOptions$: Observable<PDropdownOption[]> = observableOf([]);
    warningTooltip = `The first ${this.assetLimit.toLocaleString()} records of your search are displayed. Please apply additional filters to narrow your search.`;
    filterText: string;
    tempFilterSelections: { [key: string]: any[] } = {};
    filterTimeout: any = null;
    canAccessAssetDetailsInDivision: boolean;
    canAccessAssetDetailsInFranchise: boolean;
    customFieldSub: Subscription;
    /** For the showing dropdown */
    assetToggleOptions = [];
    // style classes are so the options can be tagged in Pendo
    acceptBulkOption = { label: 'Accept Assets', disabled: true, command: () => this.updateSelectedAssets(), styleClass: 'adt-bulk-accept' };
    addToEventOption = { label: 'Add to Event', command: () => { this.openAddToEventModal(); }, styleClass: 'adt-bulk-add-to-event' };
    copyToEventOption = { label: 'Copy to Event', command: () => { this.openAddToEventModal(); }, styleClass: 'adt-bulk-add-to-event' };
    addGroupsOption = { label: 'Add Groups', command: () => { this.openAddGroupsModal(); }, styleClass: 'adt-bulk-update-groups' };
    checkInOption = { label: 'Check In', command: () => this.checkIn(), styleClass: 'adt-bulk-event-check-in' };
    checkOutOption = { label: 'Check Out', command: () => this.checkOut(), styleClass: 'adt-bulk-event-check-out' };
    createReportOption = { label: 'PDF', command: () => this.createAssetReport(false), styleClass: 'adt-bulk-export-pdf' };
    createAssetReportOption = { label: 'Asset Page(s)', command: () => this.createAssetReport(true), styleClass: 'adt-bulk-export-asset-page' };
    createAssetFromTrxOption = { label: 'Create 1 Asset', command: () => this.createAssetFromTrx(), styleClass: 'adt-bulk-reconcile-create-asset' };
    updateCharOption = { label: 'Character', command: () => this.openCharacterModal(), styleClass: 'adt-bulk-update-char' };
    exportCSVOption = { label: 'CSV', command: () => this.exportCSV(), styleClass: 'adt-bulk-export-csv' };
    matchToExistingOption = { label: 'Match - Existing Asset(s)', command: () => this.matchToExistingAsset(), styleClass: 'adt-bulk-reconcile-match-to-existing' };
    matchToReviewOption = { label: 'Match - SOS Inventory', command: () => this.matchToReviewAsset(), styleClass: 'adt-bulk-reconcile-match-to-sos-inventory' };
    mergeAssetsOption = { label: 'Merge Two Assets', command: () => this.openMergeAssetsModal(), styleClass: 'adt-bulk-merge' };
    moveOption = { label: 'Move', command: () => this.openMoveModal(), styleClass: 'adt-bulk-move' };
    requestAssetsOption = { label: 'Request', command: () => { this.openRequestAssetsModal(); }, styleClass: 'adt-bulk-request-add' };
    removeFromEventOption = { label: 'Remove from Event', command: () => this.removeFromTable(), styleClass: 'adt-bulk-event-remove' };
    removeFromRequestOption = { label: 'Remove from Request', command: () => this.removeFromTable(), styleClass: 'adt-bulk-request-remove' };
    toggleExcludedBulkOption = { label: '', command: () => this.toggleExcluded(), styleClass: 'adt-bulk-exclude' };
    updateDepartmentOption = { label: 'Department', command: () => this.openDepartmentModal(), styleClass: 'adt-bulk-update-department' };
    updateDispositionOption = { label: 'Disposition', command: () => this.openDispositionModal(), styleClass: 'adt-bulk-update-disposition' };
    updateExcludedDispositionOption = { label: 'Excluded Disposition', command: () => this.openExcludedDispositionModal(), styleClass: 'adt-bulk-update-disposition' };
    updateFranchiseInfoOption = { label: 'Feature/Series', command: () => { this.openMoveFranchiseInfoModal(); }, styleClass: 'adt-bulk-update-franchise-info' };
    updateSetOption = { label: 'Set', command: () => this.openSetModal(), styleClass: 'adt-bulk-update-set' };
    updateStatusOption = { label: 'Status', command: () => { this.openStatusModal(); }, styleClass: 'adt-bulk-update-status' };
    updateCustomFieldOption = { label: 'Field', command: () => { this.openCustomFieldModal(); }, styleClass: 'adt-bulk-update-field' };
    removeAssetsFromGroup = { label: 'Remove', command: () => { this.removeAssetsFromGroups(); }, styleClass: 'adt-bulk-update-groups' };
    removeAssetsFromSubGroup = { label: 'Remove', command: () => { this.removeAssetsFromSubGroups(); }, styleClass: 'adt-bulk-update-sub-groups' };
    transferToEventOption = { label: 'Transfer to Event', command: () => { this.openTransferToEventModal(); }, styleClass: 'adt-bulk-add-to-event' };
    addPhotosOption = { label: 'Add Photos', command: () => { this.openAddPhotosModal(); }, styleClass: 'adt-bulk-add-photos' };
    bulkTrashOption = { label: 'Move to Trash', command: () => { this.bulkMoveAsset(); }, styleClass: 'adt-bulk-trash' };
    addAttachmentOption = { label: 'Add Attachment', command: () => { this.openAddAttachmentModal(); } };
    exportOptions = [];
    fullExportOptions = [
        this.exportCSVOption,
        this.createReportOption,
        this.createAssetReportOption
    ];
    addUpdateOptions = [];
    eventOptions = [];
    moveOptionVisible = false;
    mergeOptionVisible = false;
    requestOptionVisible = false;

    bulkReconcileOptions = [this.createAssetFromTrxOption, this.matchToExistingOption, this.matchToReviewOption];
    lazyAssets: Asset[];
    lazyTransactions: Transaction[];
    transactionToggleOptions = [
        { label: 'Unreconciled Transactions', value: TransactionTypes.Unreconciled },
        { label: 'Reconciled Transactions', value: TransactionTypes.Reconciled },
        { label: 'All Transactions', value: TransactionTypes.All }
    ];
    TransactionTypes = TransactionTypes;

    private subs: Subscription;
    isStudioAdmin: any;
    windowScrolled: boolean;

    scrollEventValue: any;
    scrollContentName: string = "main-content";
    divisionChar$: Observable<any[]>;
    divisionSet$: Observable<any[]>;
    showCharSet = [];
    isExportAllVisible = false;
    loadInitiatedMap: Map<string, boolean>;
    paginatorTopDomLoop = 0;
    colFilterValues = [];
    nullDisabledMap: { [key: string]: boolean } = {};
    private allFieldOptionsSnapshot: PDropdownOption[] = [];
    fieldHeightMap: { [canonicalName: string]: number } = {};

    constructor(private store: Store<fromRoot.State>, private router: Router, public dialog: MatDialog, private transactionDataService: TransactionDataService, private transactionFormService: TransactionFormService, private route: ActivatedRoute, public breakpointObserver: BreakpointObserver, public deviceService: DeviceDetectorService, public bulkMoveModalDataService: BulkMoveModalDataService, private localStorageService: LocalStorageService, private attServ: AssetAttachmentService) { }

    scroll = (event: any): void => {
        this.scrollEventValue = event;

        if (event.srcElement.scrollTop > 200 && event.target.className === this.scrollContentName) {
            this.windowScrolled = true;
        }
        else {
            this.windowScrolled = false;
        }
    };
    heightPixel: number = 5;

    scrollToTop() {
        this.scrollEventValue.srcElement.scrollTop = 0;
    }
    // Manually updating the logic for choose columns adjusting height. 
    // We have to re-verify the fix was done on Primeng and remove this logic
    onFilterChange(event: any) {
        const query = event.filter?.toLowerCase() || '';
        let filteredResults = [];
        const sourceOptions = this.allFieldOptionsSnapshot.length ? this.allFieldOptionsSnapshot : this.allFieldOptions;

        if (query) {
            filteredResults = sourceOptions.filter(option => {
                const label = option.label.toLowerCase();

                if (label.includes(query)) {
                    return true;
                }

                const inputText = label.split(' ');
                if (inputText.some(input => input.startsWith(query))) {
                    return true;
                }

                return false;
            });
        } else {
            filteredResults = sourceOptions;
        }
        this.heightPixel = filteredResults.length;
    }

    onMultiselectFilterChanges(event: any, field: any) {
        const query = event.filter?.toLowerCase() || '';
        const options = field === this.standardFields.origin_currency.canonical_name
            ? this.selectOptions.project_currency_id
            : this.selectOptions[field] || [];

        const filteredResults = query
            ? options.filter(option => option.label?.toLowerCase().includes(query))
            : options;

        this.fieldHeightMap = { ...this.fieldHeightMap, [field]: filteredResults.length };
    }

    getMultiSelectPanelStyle(field: any): { [key: string]: string } {
        const canonicalName = field?.canonical_name;

        // Use filtered height if available, otherwise fall back to full options count
        if (this.fieldHeightMap[canonicalName] !== undefined) {
            return { '--item-count': String(this.fieldHeightMap[canonicalName]) };
        }

        const options = canonicalName === this.standardFields?.origin_currency?.canonical_name
            ? this.selectOptions?.project_currency_id
            : this.selectOptions?.[canonicalName];

        const optionCount = options?.length ?? 5;
        return { '--item-count': String(optionCount) };
    }

    ngOnInit() {
        window.addEventListener('scroll', this.scroll, true);
        // Set custom filter methods on TT - this will maybe mostly fix the bug in AH-598
        this.isStudioAdmin = this.user.permission.isStudioAdmin(this.currentStudioId);
        if (this.columnFilterService) {
            this.columnFilterService.setCustomFilterConstraints();
        }
        this.customFieldSub = this.route.parent.data.subscribe(data => {
            this.customFieldNames = data.customFieldNames;
        });
        this.route.data.pipe(filter(data => !!data), take(1)).subscribe(data => {
            if (data.selectedGroup !== undefined)
                this.groupId = data.selectedGroup.id;
            if (data.selectedSubGroup !== undefined)
                this.subGroupId = data.selectedSubGroup.id;
        });

        this.isExportAllVisible = [TableTypes.FranchiseTable, TableTypes.DivisionTable, TableTypes.StudioTable].includes(this.tableType);

        this.fieldTypes = FIELD_TYPES;
        this.standardFields = STANDARD_FIELDS;
        this.store.dispatch(new groupTypesActions.ListAction(this.currentStudioId));
        if (this.user.admin)
            this.loggedInUserIndicator = false;
        if (this.tableType === TableTypes.FranchiseTable) {
            this.isFranchiseTable = true;
            this.buildShowingDropDown();
            if (this.franchise && this.user) {
                if (!(this.user.isStudioAdmin(this.currentStudioId)))
                    this.canViewHistorical = this.user.permission.canViewHistorical(this.franchise.id, this.franchise.studio_id);
                this.canEdit = this.user.permission.canEditInFranchise(this.franchise.id, this.franchise.studio_id);
            }
            this.setBulkOptionsByEditPerms();
        } else if (this.tableType === TableTypes.TransactionTable) {
            this.isTransactionTable = true;
            this.toggleExcludedBulkOption.label = AssetDataTableComponent.TOGGLE_EXCLUDED_LABELS[this.indexType];
        } else if (this.tableType === TableTypes.DivisionTable) {
            this.isDivisionTable = true;
            this.buildShowingDropDown();
            if (this.division && this.user) {
                this.canEdit = this.user.permission.canEditInDivision(this.division.id, this.division.studio_id);
            }
            this.updateFranchiseInfoOption.label = this.customFieldNames ? `${this.customFieldNames.franchise_id}/${this.customFieldNames.series_id}` : 'Feature/Series';
        } else if (this.tableType === TableTypes.EventTable) {
            this.isEventTable = true;
            if (this.division && this.user) {
                this.canEdit = this.user.permission.canEditInDivision(this.division.id, this.division.studio_id);
            }
        } else if (this.tableType === TableTypes.DivisionGroupTable || this.tableType === TableTypes.FranchiseGroupTable || this.tableType === TableTypes.StudioGroupTable) {
            this.buildShowingDropDown();
            if (this.tableType === TableTypes.DivisionGroupTable) {
                this.isDivisionGroupTable = true;
                this.canEdit = this.user.permission.canEditInDivision(this.division.id, this.division.studio_id);
            } else if (this.tableType === TableTypes.FranchiseGroupTable) {
                this.isFranchiseGroupTable = true;
                this.canEdit = this.user.permission.canEditInFranchise(this.franchise.id, this.franchise.studio_id);
            } else {
                this.isStudioGroupTable = true;
                this.canEdit = this.user.permission.isStudioAdmin(this.currentStudioId);
            }
        } else if (this.tableType === TableTypes.RequestTable) {
            this.isRequestTable = true;
        } else if (this.tableType === TableTypes.StudioTable) {
            this.isStudioTable = true;
            this.canEdit = this.user.permission.isStudioAdmin(this.currentStudioId);
        } else if (this.tableType === TableTypes.DivisionSubGroupTable || this.tableType === TableTypes.FranchiseSubGroupTable || this.tableType === TableTypes.StudioSubGroupTable) {
            this.buildShowingDropDown();
            if (this.tableType === TableTypes.DivisionSubGroupTable) {
                this.isDivisionSubGroupTable = true;
                this.canEdit = this.user.permission.canEditInDivision(this.division.id, this.division.studio_id);
            } else if (this.tableType === TableTypes.FranchiseSubGroupTable) {
                this.isFranchiseSubGroupTable = true;
                this.canEdit = this.user.permission.canEditInFranchise(this.franchise.id, this.franchise.studio_id);
            } else {
                this.isStudioSubGroupTable = true;
                this.canEdit = this.user.permission.isStudioAdmin(this.currentStudioId);
            }
        }
        this.updateBulkOptions();

        // Set default sort if no session table state
        const tableState = JSON.parse(localStorage.getItem(this.stateKey));
        if (tableState && tableState.rows) {
            this.rowsPerPage = tableState.rows;
        } else {
            this.rowsPerPage = this.defaultRowsPerPage();
        }

        if (!tableState || !tableState.sortField) {
            // Just sets the sort icon direction on the table to show the default sort
            this.turboTable.sortField = assetTableDefaultSortObject.field;
            this.turboTable.sortOrder = assetTableDefaultSortObject.order;
        }

        if (this.tableType !== TableTypes.TransactionTable && this.tableType !== TableTypes.RequestTable) {
            this.setBulkOptionsByEditPerms();
        }
        this.addCharSetOptions();

        this.characters$ = this.store.select(characterSelectors.forSelectedInlineEditAssetProject);
        this.characterOptions$ = makeCharOrSetDropdown(this.characters$, true);
        this.sets$ = this.store.select(setSelectors.forSelectedInlineEditAssetProject);
        this.setOptions$ = makeCharOrSetDropdown(this.sets$, false);
        this.modalDispositions$ = this.store.select(fromRoot.getDispositions).pipe(filter(disps => !!disps));
        this.dispositionOptions$ = this.modalDispositions$.pipe(map(disps => buildPDropdownOptions(disps, {
            nullOption: true,
            nullLabel: 'Disposition *'
        })));
        this.modalStatuses$ = this.store.select(fromRoot.getStatuses).pipe(filter(statuses => !!statuses));
        this.statusOptions$ = this.modalStatuses$.pipe(map(statuses => buildPDropdownOptions(statuses, {
            nullOption: true,
            nullLabel: 'Status'
        })));
        this.subDepartments$ = this.store.select(subDepartmentSelectors.getSubDeptsForSelectedInlineEditDept);
        this.subDepartmentOptions$ = this.subDepartments$.pipe(map(subdepts => buildPDropdownOptions(subdepts, {
            nullOption: true,
            nullLabel: 'Sub Department'
        })));
        this.modalProjectCurrencies$ = this.store.select(projectCurrencySelectors.getForInlineEditSelectedProject);
        this.projectCurrencyOptions$ = makeProjectCurrencyDropdown(this.modalProjectCurrencies$);
        this.canAccessAssetDetailsInDivision = this.division && this.user && this.user.permission ? this.user.permission.canAccessAssetDetailsInDivision(this.division.id, this.division.studio_id) : false;
        this.canAccessAssetDetailsInFranchise = this.franchise && this.user && this.user.permission ? this.user.permission.canAccessAssetDetailsInFranchise(this.franchise.id, this.franchise.studio_id) : false;

        this.setupSubscriptions();

        let first = 0;
        let rows = 50;

        if (tableState) {
            if (!tableState.first) {
                tableState.first = 0;
            } else {
                first = tableState.first;
            }

            if (!tableState.rows) {
                tableState.rows = 50;
            } else {
                rows = tableState.rows;
            }
        }
        this.loadInitiatedMap = new Map<string, boolean>();
        this.loadInitiatedMap[`${this.stateKey}-${first}-${rows}`] = true;
        this.loadTempFilterSelectionsOnPicklist();
    }

    showTooltip() {
        this.tooltip = false;
    }

    hideTooltip() {
        this.tooltip = true;
        this.heightPixel = 5;
    }


    ngOnChanges(changes: SimpleChanges) {
        const tableState = JSON.parse(localStorage.getItem(this.stateKey) ?? 'null');
        const { selectedProjectIdsList, selectedDepartmentIdsList, selectedWarehouseIdsList } = changes;
        // Set default filters (only used for Match Assets Table)
        if (changes.defaultFilters) {
            if (!tableState && (this.isTransactionMatchTable || this.isTransactionMatchReviewTable) && this.defaultFilters) {
                const filters: TableFilterObject = this.defaultFilters;

                Object.keys(filters).forEach(canonicalName => {
                    this.turboTable.filter(filters[canonicalName].value, canonicalName, 'in');
                });
            }
        }
        if (changes.filters) {
            const previousValueLength = changes?.filters?.previousValue ? Object.keys(changes?.filters?.previousValue)?.length : 0;
            const currentValueLength = changes?.filters?.currentValue ? Object.keys(changes?.filters?.currentValue)?.length : 0;
            if (currentValueLength === 0 && previousValueLength === 0) {
                this.disableClearFilter = true;
            } else if (JSON.stringify(changes.filters.previousValue) !== JSON.stringify(changes.filters.currentValue)) {
                this.disableClearFilter = hideClearFilter(changes.filters.currentValue);
            }
        }
        if (changes.filters && changes.filters.currentValue) {
            this.loadTempFilterSelectionsOnPicklist();

        }
        if (changes.allFieldOptions && changes.allFieldOptions.currentValue) {
            this.allFieldOptionsSnapshot = [...changes.allFieldOptions.currentValue];
        }

        /**
         * Reset page if sidenav selected projects, departments, or warehouses change
         * Filters change whenever sidenav filters change so this runs twice, but TT seems to need that
         * Reset page only if changing from one meaningful value to another (i.e. not initializing the page)
         */
        if (selectedProjectIdsList && selectedProjectIdsList.currentValue && selectedProjectIdsList.previousValue && selectedProjectIdsList.previousValue.length && (selectedProjectIdsList.currentValue.length !== selectedProjectIdsList.previousValue.length || selectedProjectIdsList.currentValue[0] !== selectedProjectIdsList.previousValue[0])) {
            this.turboTable.onPageChange({ first: 0, rows: this.rowsPerPage });
        } else if (selectedDepartmentIdsList && selectedDepartmentIdsList.currentValue && selectedDepartmentIdsList.previousValue && selectedDepartmentIdsList.previousValue.length && selectedDepartmentIdsList.currentValue.length !== selectedDepartmentIdsList.previousValue.length) {
            this.turboTable.onPageChange({ first: 0, rows: this.rowsPerPage });
        } else if (selectedWarehouseIdsList && selectedWarehouseIdsList.currentValue && selectedWarehouseIdsList.previousValue && selectedWarehouseIdsList.previousValue.length && selectedWarehouseIdsList.currentValue.length !== selectedWarehouseIdsList.previousValue.length) {
            this.turboTable.onPageChange({ first: 0, rows: this.rowsPerPage });
        }

        // Set TT value to saved page slice if it exists, otherwise set to default
        if (this.assets && this.assets.length > 0) {
            // TurboTable doesn't set totalRecords automatically when lazyload is activated, so set that whenever assets/transactions change
            this.turboTable.totalRecords = this.assetCountTotal;
            if (!this.isAllAssetsSelected) {
                if (tableState) {
                    const sessionLazyAssets: Asset[] = this.assets.slice(tableState.first, tableState.first + tableState.rows);
                    this.lazyAssets = sessionLazyAssets.length ? sessionLazyAssets : this.assets.slice(0, this.rowsPerPage);
                } else {
                    this.lazyAssets = this.assets.slice(0, this.rowsPerPage ? this.rowsPerPage : this.defaultRowsPerPage());
                }
                this.lazyAssets = this.lazyAssets.filter(a => a != null);
                if (!this.turboTable.first) {
                    this.turboTable.first = 0;
                }
                this.turboTable.rows = this.rowsPerPage;
                // Commmented the following line to prevent turboTable from resetting the page on asset selection
                // this.clearAllSelectedAssets();
            }
            else {
                this.lazyAssets = this.assets;
                this.lazyAssets = this.lazyAssets.filter(a => a != null);
                this.selectAll();
                this.turboTable.first = 0;
            }
        } else if (!this.isTransactionTable) {
            this.lazyAssets = [];
            this.turboTable.totalRecords = 0;
        }
        if (this.transactions && this.transactions.length > 0) {
            this.turboTable.totalRecords = this.transactions.length;
            if (!this.isAllAssetsSelected) {
                if (tableState) {
                    const sessionLazyTransactions: Transaction[] = this.transactions.slice(tableState.first, tableState.first + tableState.rows);
                    this.lazyTransactions = sessionLazyTransactions.length ? sessionLazyTransactions : this.transactions.slice(0, this.rowsPerPage);
                } else {
                    this.lazyTransactions = this.transactions.slice(0, this.rowsPerPage ? this.rowsPerPage : this.defaultRowsPerPage());
                }
                this.lazyTransactions = this.lazyTransactions.filter(a => a != null);
                this.turboTable.rows = this.rowsPerPage;
                this.clearAllSelectedTransactions();
            } else {
                this.lazyTransactions = this.transactions;
                this.lazyTransactions = this.lazyTransactions.filter(a => a != null);
                this.selectAll();
                this.turboTable.first = 0
                this.turboTable.rows = this.rowsPerPage;
            }
        } else if (this.isTransactionTable && this.transactions && this.transactions.length === 0) {
            this.lazyTransactions = [];
            this.turboTable.totalRecords = 0;
            this.turboTable.first = 0
            this.turboTable.rows = this.rowsPerPage;
            this.lazyLoad({ first: this.turboTable.first, rows: this.turboTable.rows });
        }

        // The reason for checking the table type vs isFranchiseTable, is because the digest cycle sometimes runs ngOnChanges before the ngOnInit where it gets set when switching between pages

        if ((this.tableType === TableTypes.FranchiseTable) && (changes.currentView || changes.assets || changes.selectedDepartmentIdsList || changes.selectedProjectIdsList || changes.updateCharSetOptions)) {
            this.updateBulkOptions();
            this.addCharSetOptions();
            this.setBulkOptionsByEditPerms();
        } else if ((this.tableType === TableTypes.TransactionTable) && (changes.currentView || changes.transactions || changes.selectedDepartmentIdsList || changes.selectedProjectIdsList || changes.updateCharSetOptions)) {
            this.addCharSetOptions();
        } else if (this.tableType === TableTypes.DivisionTable) {
            this.updateBulkOptions();
            if (changes.currentView && !changes.currentView.firstChange) {
                this.loadInitiatedMap = new Map<string, boolean>();
                this.lazyLoad({
                    first: this.turboTable.first || 0,
                    rows: this.turboTable.rows || this.rowsPerPage
                });
            }
        }

        if (this.responsive && (changes.selectedFields || changes.selectedFieldOptions)) {
            this.changeColumnFieldsForMobile();
        }

        if (changes.selectedDepartmentIdsList || changes.selectedProjectIdsList || changes.selectedWarehouseIdsList) {
            this.clearAllSelectedItems();
        }

        // Condition for hide Qty. On Hand in All Groups and Asset Type Everything
        if ((this.tableType === TableTypes.DivisionGroupTable || this.tableType === TableTypes.StudioGroupTable || this.tableType === TableTypes.FranchiseGroupTable) && this.assetTypesShown === AssetTypes.All) {
            this.allFieldOptions = this.allFieldOptions ? this.allFieldOptions.filter(val => val.label !== STANDARD_FIELDS.qty_on_hand.name) : this.allFieldOptions;
            this.selectedFields = this.selectedFields ? this.selectedFields.filter(val => val.canonical_name !== STANDARD_FIELDS.qty_on_hand.canonical_name) : this.selectedFields;
        }

        if (this.tableType !== TableTypes.DivisionTable) {
            this.allFieldOptions = this.allFieldOptions ? this.allFieldOptions.filter(val => val.label !== STANDARD_FIELDS.assetEvents.name) : this.allFieldOptions;
        }

        if (this.turboTable.first > 0) {
            this.lazyLoad({ first: this.turboTable.first, rows: this.turboTable.rows });
        }
    }

    updateFieldOptions() {
        this.allFieldOptions = this.allFieldOptions?.filter(val => !DEFAULT_FREE_FIELDS_NAME.includes(val.label));
        this.selectedFields = this.selectedFields?.filter(field => !DEFAULT_FREE_FIELDS_NAME.includes(field.name));
    }
    removeQuotes(string = '') {
        return string.replace(/"/g, '');
    }

    loadTempFilterSelectionsOnPicklist() {
        Object.keys(this.filters || {}).forEach(fieldKey => {
            const filter = this.filters[fieldKey];
            if (filter?.value && Array.isArray(filter.value)) {
                this.tempFilterSelections[fieldKey] = [...filter.value];
            } else if (filter?.value) {
                this.tempFilterSelections[fieldKey] = [filter.value];
            }
        });
    }

    ngOnDestroy() {
        if (this.subs) {
            this.subs.unsubscribe();
        }
        window.removeEventListener('scroll', this.scroll, true);
    }

    ngAfterViewInit(): void {
        const table = this.turboTable.el.nativeElement.querySelector('table');
        table.setAttribute('id', 'pn_id_4-table');
    }

    ngAfterViewChecked() {
        if (this.paginatorTopDomLoop < 2) {
            this.paginatorTopDomLoop++;
        }

        if (this.columnFilterService) {
            // FilterUtils['between'] = this.columnFilterService.numberBetweenFunction;
            // FilterUtils['betweenCurrency'] = this.columnFilterService.getCurrencyBetweenFunction(this.columnFilterService);
        }
    }

    openMultiSelect(e) {
        this.multiSelect.show();
        e.stopPropagation();
    }

    canAccessAssetDetails(assetLike) {
        if (this.user && this.user.permission) {
            if (assetLike.division_id) {
                return this.user.permission.canAccessAssetDetailsInDivision(assetLike.division_id, assetLike.studio_id);
            } else {
                return this.user.permission.canAccessAssetDetailsInFranchise(assetLike.franchise_id, assetLike.studio_id);
            }
        }
        return false;
    }

    changeColumnFieldsForMobile() {
        // For mobile, move Photo, Name and Description fields to beginning of selectedFields if selected
        this.moveColumnField(STANDARD_FIELDS.description.canonical_name);
        this.moveColumnField(STANDARD_FIELDS.name.canonical_name);
        if (!this.isTransactionTable) {
            this.moveColumnField(STANDARD_FIELDS.photos.canonical_name);
        }
        this.selectedFieldOptions = this.selectedFields.map(f => f.id);
    }

    matchToExistingAsset() {
        const transactions = this.getShowingTransactions().filter((trans) => this.selectedTransactions.has(trans.id));
        const isValid = this.checkTrxSameValues(transactions);
        if (isValid) {
            const transactionIds = transactions.map(t => t.id).join(',');
            this.router.navigate(['./match-assets', { transactions: transactionIds, selectedProjectIdsList: this.selectedProjectIdsList }], { relativeTo: this.route });
        }
    }

    matchToReviewAsset() {
        const transactions = this.getShowingTransactions().filter((trans) => this.selectedTransactions.has(trans.id));
        const isValid = this.checkTrxSameValues(transactions);
        if (isValid) {
            const transactionIds = transactions.map(t => t.id).join(',');
            this.router.navigate(['./match-review', { transactions: transactionIds }], { relativeTo: this.route });
        }
    }

    /** Check that all trx have the same dept, subdept, origin currency, char, set, sub location */
    checkTrxSameValues(transactions: Transaction[]): boolean {
        const deptField = this.fields.find(f => f.canonical_name === STANDARD_FIELDS.department.canonical_name);
        const subDeptField = this.fields.find(f => f.canonical_name === STANDARD_FIELDS.sub_department.canonical_name);
        const origCurrField = this.fields.find(f => f.canonical_name === STANDARD_FIELDS.origin_currency.canonical_name);
        const charField = this.fields.find(f => f.canonical_name === STANDARD_FIELDS.character.canonical_name);
        const setField = this.fields.find(f => f.canonical_name === STANDARD_FIELDS.set.canonical_name);
        const deptName = deptField ? deptField.name : 'Department';
        const charName = charField ? charField.name : 'Character';
        const setName = setField ? setField.name : 'Set';
        let transactionMessage = [];
        transactionMessage.push(` The selected transactions must be in the same ${deptName}, ${subDeptField ? subDeptField.name : 'Sub Department'} and have the same ${origCurrField ? origCurrField.name : 'Origin Currency'}, ${charName}/${setName}.`);
        let isValid = true;
        transactions.some(tran => {
            if (tran.department_id !== transactions[0].department_id || tran.sub_department_id !== transactions[0].sub_department_id || tran.origin_currency !== transactions[0].origin_currency || tran.character_id !== transactions[0].character_id || tran.set_id !== transactions[0].set_id || tran.sub_location_id !== transactions[0].sub_location_id) {
                if (tran.department_id !== transactions[0].department_id || tran.sub_department_id !== transactions[0].sub_department_id) {
                    transactionMessage.push(` Use the Add/Update ${deptName} bulk option to move the transactions to the same ${deptName}.`);
                }
                if (tran.character_id !== transactions[0].character_id) {
                    transactionMessage.push(` Use the Add/Update ${charName} bulk option to set the same ${charName} to the transactions.`);
                }
                if (tran.set_id !== transactions[0].set_id) {
                    transactionMessage.push(` Use the Add/Update ${setName} bulk option to set the same ${setName} to the transactions.`);
                }
                isValid = false;
                return true;
            }
            return false;
        });

        if (!isValid) {
            this.dialog.open(ConfirmModalComponent, {
                data: {
                    transactionMessage,
                    allowCancel: false
                }
            });
        }
        return isValid;
    }

    openMergeAssetsModal() {
        // Need to update these to use custom studio field names
        const franchiseConfirmMessage = 'To merge assets, you must select more than 1 asset in the same Feature, Project, and Department.';
        const divisionConfirmMessage = 'To merge assets, you must select more than 1 asset in the same Division, Project, Warehouse, and Department.';
        const maxAssetFranchiseWarningMessage = 'To merge assets, you must select up to 5 assets in the same Feature, Project, and Department.';
        const maxAssetDivisionWarningMessage = 'To merge assets, you must select up to 5 assets in the same Division, Project, Warehouse, and Department.';
        const betweenAssetFranchiseWarningMessage = 'To merge assets, you must select assets in the same Feature, Project, and Department.';
        const betweenAssetDivisionWarningMessage = 'To merge assets, you must select assets in the same Division, Project, Warehouse, and Department.';
        if (this.selectedAssets.size > 1 && this.selectedAssets.size <= 5 && this.assetEntities) {
            const findAssets = [...new Set(this.selectedAssets)];
            let combineAsset = [];
            findAssets.map((value) => {
                combineAsset.push(this.assetEntities[value])
            })
            const department = this.departments.find(dept => dept.id === combineAsset[0].department_id);
            const fieldIdsForDepartment = department ? department.departmentFields.map(df => df.field_id) : [];
            const fields = fieldIdsForDepartment.length ? this.fields.filter(field => fieldIdsForDepartment.includes(field.id)) : this.fields;

            const modalData: MergeAssetsModalData = {
                fields,
                tableType: this.tableType,
                combineAsset
            };
            const sameFranchise = combineAsset.filter((value, index, asset) => asset.findIndex(val => ['franchise_id', 'project_id', 'department_id'].every(k => val[k] === value[k])) === index);
            const sameDivision = combineAsset.filter((value, index, asset) => asset.findIndex(val => ['division_id', 'warehouse_id', 'franchise_id', 'department_id'].every(k => val[k] === value[k])) === index);
            if (this.tableType === TableTypes.FranchiseTable || this.tableType === TableTypes.FranchiseGroupTable || this.tableType === TableTypes.FranchiseSubGroupTable) {
                if (sameFranchise.length === 1) {
                    this.dialog.open(MergeAssetsModalComponent, {
                        data: modalData,
                        panelClass: 'static-width',
                        maxWidth: '80vw'
                    }).afterClosed().pipe(take(1)).subscribe(result => {
                        if (result) {
                            this.clearAllSelectedAssets()
                        }
                    });
                } else {
                    this.dialog.open(ConfirmModalComponent, {
                        data: {
                            title: 'Merge Assets',
                            message: combineAsset.length < 3 ? franchiseConfirmMessage : betweenAssetFranchiseWarningMessage,
                            allowCancel: false
                        }
                    });
                }
            } else if (this.tableType === TableTypes.DivisionTable || this.tableType === TableTypes.DivisionGroupTable || this.tableType === TableTypes.DivisionSubGroupTable) {
                if (sameDivision.length === 1) {
                    this.dialog.open(MergeAssetsModalComponent, {
                        data: modalData,
                        panelClass: 'static-width',
                        maxWidth: '80vw'
                    }).afterClosed().pipe(take(1)).subscribe(result => {
                        if (result) {
                            this.clearAllSelectedAssets();
                        }
                    });

                } else {
                    this.dialog.open(ConfirmModalComponent, {
                        data: {
                            title: 'Merge Assets',
                            message: combineAsset.length < 3 ? divisionConfirmMessage : betweenAssetDivisionWarningMessage,
                            allowCancel: false
                        }
                    });
                }
            }
        } else {
            this.dialog.open(ConfirmModalComponent, {
                data: {
                    title: 'Merge Assets',
                    message: ([TableTypes.FranchiseTable, TableTypes.FranchiseGroupTable, TableTypes.FranchiseSubGroupTable].includes(this.tableType) && this.selectedAssets.size < 2) ? franchiseConfirmMessage
                        : ([TableTypes.FranchiseTable, TableTypes.FranchiseGroupTable, TableTypes.FranchiseSubGroupTable].includes(this.tableType) && this.selectedAssets.size > 5) ? maxAssetFranchiseWarningMessage
                            : ([TableTypes.DivisionTable, TableTypes.DivisionGroupTable, TableTypes.DivisionSubGroupTable].includes(this.tableType) && this.selectedAssets.size > 5) ? maxAssetDivisionWarningMessage
                                : divisionConfirmMessage,
                    allowCancel: false
                }
            });
        }

    }

    setBulkOptionsByEditPerms() {
        if (!this.canEdit) {
            this.exportOptions = this.fullExportOptions;
            this.addUpdateOptions = [];
            this.eventOptions = [];
            this.moveOptionVisible = false;
            this.mergeOptionVisible = false;
        }
    }

    addRequestOption() {
        this.requestOptionVisible = this.approvalsEnabled ? true : false;
    }

    addCharSetOptions() {
        this.addUpdateOptions = this.addUpdateOptions.filter(item => item !== this.updateCharOption && item !== this.updateSetOption);
        if (this.updateCharSetOptions) {
            this.addUpdateOptions.splice(0, 0, this.updateCharOption);
            this.addUpdateOptions.splice(1, 0, this.updateSetOption);
        }
    }

    approveAssets(approve: boolean) {
        const assetIds = this.getShowingAssetIds().filter(assetId => this.selectedAssets.has(assetId));
        const assets = assetIds.map(assetId => this.assets.find(a => a.id === assetId));
        const requestAssetIds = assets.map(asset => asset.requestAsset.id);
        if (assetIds) {
            this.store.dispatch(new requestAssetActions.UpdateAction({ request_id: this.request.id, request_asset_ids: requestAssetIds, approve }));
            this.clearAllSelectedAssets();
        }
    }

    onShowRequestConflicts(event, requestAssetId: number) {
        event.stopPropagation();
        this.showRequestConflicts.emit(requestAssetId);
    }

    isRequestConflictColumnVisible() {
        return this.isRequestTable && (this.request.status !== RequestStatus.Unsent && this.request.status !== RequestStatus.Closed);
    }

    isRequestStatusColumnVisible() {
        return this.isRequestTable && ((this.requestType === RequestTypes.Requester && (this.request.status === RequestStatus.Complete || this.request.status
            === RequestStatus.Closed)) || this.requestType !== RequestTypes.Requester);
    }

    isRequestSentToColumnVisible() {
        return this.isRequestTable && this.requestType === RequestTypes.Approver && this.finalApproversEnabled;
    }

    onRowClick(event: MouseEvent, assetLike) {
        if (!event.shiftKey) {
            if (this.showPillColumn) {
                // For Review, allow edit
                if (this.canEdit) {
                    this.openEditDialog(assetLike);
                } else {
                    this.store.dispatch(new layoutActions.ErrorAction({
                        error: new HttpErrorResponse({
                            error: new Error('You do not have permission to edit assets in this project.')
                        })
                    }));
                }
            } else if (this.isTransactionTable) {
                this.expandRow(assetLike);
            } else if (this.isTransactionMatchTable || this.isTransactionMatchReviewTable) {
                return;
            } else {
                if (event.target && event.target['target'] === '_blank') {
                    // If a url field type is clicked on, don't navigate to asset view
                    return;
                } else if (this.canAccessAssetDetails(assetLike)) {
                    this.goToAssetView(assetLike);
                } else {
                    this.store.dispatch(new layoutActions.ErrorAction({
                        error: new HttpErrorResponse({
                            error: new Error('You do not have permission to view further details about this asset.')
                        })
                    }));
                }
            }
        }
    }

    openInlineEdit(event: MouseEvent, field: Field, asset: Asset) {
        if (event.shiftKey) {
            if (this.assetTypesShown !== AssetTypes.Historical) {
                let canEdit = false;

                if (asset.division_id && this.user.permission.canEditInDivision(asset.division_id, asset.studio_id)) {
                    canEdit = true;
                } else if (asset.franchise_id && this.user.permission.canEditInFranchise(asset.franchise_id, asset.studio_id)) {
                    canEdit = true;
                }

                if (canEdit && this.dialog.openDialogs.length === 0 && !this.isTransactionTable) {
                    if (asset.division_id && field.canonical_name === STANDARD_FIELDS.disposition.canonical_name && field.visibility !== FieldVisibility.All && field.visibility !== FieldVisibility.Division) {
                        this.store.dispatch(new layoutActions.ErrorAction({ error: { error: new Error('This Asset is owned by a Division and this field cannot be updated.') } }));
                        return;
                    }
                    if (field != undefined) {
                        if (field.canonical_name === this.standardFields.character.canonical_name) {
                            this.options$ = this.characterOptions$;
                        } else if (field.canonical_name === this.standardFields.set.canonical_name) {
                            this.options$ = this.setOptions$;
                        } else if (field.canonical_name === this.standardFields.disposition.canonical_name) {
                            this.options$ = this.dispositionOptions$;
                        } else if (field.canonical_name === this.standardFields.status.canonical_name) {
                            this.options$ = this.statusOptions$;
                        } else if (field.canonical_name === this.standardFields.sub_department.canonical_name) {
                            this.options$ = this.subDepartmentOptions$;
                        } else if (field.canonical_name === this.standardFields.origin_currency.canonical_name) {
                            this.options$ = this.projectCurrencyOptions$;
                        } else if (field.picklistOptions) {
                            this.options$ = observableOf(
                                buildPDropdownOptions(field.picklistOptions, {
                                    nullOption: true,
                                    nullLabel: field.name,
                                    custom: true
                                })
                            );
                        }
                    }

                    const data: InlineEditModalData = {
                        asset,
                        event,
                        field,
                        departments: this.departments,
                        divisionId: this.division ? this.division.id : null,
                        isEventTable: this.isEventTable,
                        isFranchiseTable: this.isFranchiseTable,
                        isDivisionTable: this.isDivisionTable,
                        isFranchiseGroupTable: this.isFranchiseGroupTable,
                        isDivisionGroupTable: this.isDivisionGroupTable,
                        isFranchiseSubGroupTable: this.isFranchiseSubGroupTable,
                        isDivisionSubGroupTable: this.isDivisionSubGroupTable,
                        isTransactionMatchReviewTable: this.isTransactionMatchReviewTable,
                        isTransactionMatchTable: this.isTransactionMatchTable,
                        options$: this.options$,
                        allGroups$: this.allGroups$,
                        divisionGroups$: this.divisionGroups$,
                        notDivisionGroups$: this.notDivisionGroups$,
                        franchiseGroups$: this.franchiseGroups$,
                        notFranchiseGroups$: this.notFranchiseGroups$,
                        franchise: this.franchise
                    };

                    const config: MatDialogConfig = {
                        data,
                        width: '250px',
                        backdropClass: 'backdrop',
                        autoFocus: true,
                    };
                    this.dialog.open(InlineEditModalComponent, config).
                        afterClosed().pipe(take(1)).subscribe(didUpdate => {
                            if (didUpdate) {
                                if (this.isDivisionTable) {
                                    this.store.dispatch(new assetActions.ListByDivisionFiltersAction({ divisionId: this.division.id, assetTypes: this.assetTypesShown }));
                                } else if (this.isFranchiseTable) {
                                    this.store.dispatch(new assetActions.ListByFranchiseFiltersAction({ franchiseId: this.franchise.id, assetTypes: this.assetTypesShown }));
                                } else if (this.isEventTable) {
                                    this.store.dispatch(new assetActions.ListByEventFiltersAction({ eventId: this.event.id }));
                                } else if (this.isRequestTable) {
                                    this.store.dispatch(new assetActions.ListByRequestFiltersAction({ request_id: this.request.id }));
                                } else {
                                    // we are added else condtion for closing the block;
                                }
                                this.assetUpdated.emit();
                            }
                        });
                } else if (!canEdit && event.shiftKey && this.dialog.openDialogs.length === 0 && !this.isTransactionTable) {
                    this.store.dispatch(new layoutActions.ErrorAction({
                        error: new HttpErrorResponse({
                            error: new Error('You do not have permission to edit assets in this project.')
                        })
                    }));
                }
            } else {
                const message = 'Assets can not be edited when viewing Historical assets';
                this.store.dispatch(new layoutActions.InfoAction({ message }));
            }
        }
    }

    openEditDialog(asset: Asset) {
        this.assetModalDataService.openModal(this.dialog, ASSET_MODAL_TYPE.EDIT_INDEX, this.user, this.tableType, asset, true, this.customFieldNames);
    }

    moveSelectedToExcluded() {
        const transToUpdate = this.transactions
            .filter((trans) => this.selectedTransactions.has(trans.id))
            .map((selTrans) => new Transaction({ ...selTrans, excluded: 1 }));
        this.store.dispatch(new transactionActions.UpdateMultipleAction({
            franchiseId: this.franchise.id,
            transactions: transToUpdate
        }));
    }

    onOpenCreateDialog() {
        this.openCreateDialog.emit();
    }

    onSelectProjectCurrency(projectCurrencyId: number) {
        this.selectProjectCurrency.emit(projectCurrencyId);
    }

    updateSelectedAssets() {
        const assetsToUpdate = this.getShowingAssets()
            .filter(a => this.selectedAssets?.has(a.id) && this.assetValidLookup[a.id])
        if (assetsToUpdate.length) {
            const studioId = assetsToUpdate[0].studio_id;
            const assetsIdToUpdate = assetsToUpdate.map(asset => asset.id);
            const assetMutations = { for_review: false };
            this.isLoading = true;
            this.store.dispatch(new assetActions.UpdateMultipleAction({ assetIdList: assetsIdToUpdate, studioId, assetMutations }));
            this.store.select(fromRoot.getAssetSaving).pipe(
                filter(saving => saving !== ActionStatus.Loading),
                take(1))
                .subscribe((saving) => {
                    if (saving === ActionStatus.Complete) {
                        this.store.dispatch(new layoutActions.InfoAction({ message: `${assetsToUpdate.length} ${pluralize('Asset', assetsToUpdate.length)} ${this.assets.length > 1 ? 'have' : 'has'} been created.` }));
                        this.clearAllSelectedAssets();
                        this.onListAssetsAndFilters();
                    } else if (saving === ActionStatus.Failed) {
                        this.isLoading = false;
                    }
                });
            this.assetUpdated?.emit();
        } else {
            this.store.dispatch(new layoutActions.ErrorAction({
                error: new HttpErrorResponse({ error: new Error('There are no valid assets to update.') })
            }));
        }
    }

    openAddToEventModal() {
        const eventField = new Field(FAKE_EVENT_FIELD);
        const data: BulkModalData = {
            action: this.tableType === TableTypes.EventTable ? BULK_MODAL_ACTIONS.COPY_EVENT : BULK_MODAL_ACTIONS.EVENT,
            bulkAddToEvent: this.assetDataService.bulkAddAssetsToEvent.bind(this),
            clearSelectedAssets: this.clearAllSelectedAssets.bind(this),
            fields: [eventField],
            models: this.getShowingAssets().filter(asset => this.selectedAssets.has(asset.id)),
            events: this.events$
        };
        this.dialog.open(BulkModalComponent, { data }).afterClosed().pipe().subscribe(didUpdate => {
            if (didUpdate) {
                this.onListAssetsAndFilters();
            }
        });
    }

    openAddGroupsModal() {
        const models = this.getShowingAssets().filter(asset => this.selectedAssets.has(asset.id));
        const groupField = new Field(STANDARD_FIELDS.group_ids);
        const data: BulkModalData = {
            action: BULK_MODAL_ACTIONS.GROUPS,
            allGroups$: this.allGroups$,
            bulkAddGroupstoAssets: this.assetDataService.bulkAddGroupsToAssets.bind(this),
            clearSelectedAssets: this.clearAllSelectedAssets.bind(this),
            division: this.division,
            divisionGroups$: this.divisionGroups$,
            notDivisionGroups$: this.notDivisionGroups$,
            fields: [groupField],
            franchise: this.franchise,
            franchiseGroups$: this.franchiseGroups$,
            notFranchiseGroups$: this.notFranchiseGroups$,
            modalText: 'All selected assets will be added to the following groups',
            models,
            studioId: this.currentStudioId,
            tableType: this.tableType
        };
        this.dialog.open(BulkModalComponent, { data }).afterClosed().pipe(take(1)).subscribe(didUpdate => {
            if (didUpdate) {
                this.onListAssetsAndFilters();
            }
        });
    }
    removeAssetsFromGroups() {
        const models = this.getShowingAssets().filter(asset => this.selectedAssets.has(asset.id));
        const groupField = new Field(STANDARD_FIELDS.group_ids);
        const data: BulkModalData = {
            action: BULK_MODAL_ACTIONS.REMOVE,
            allGroups$: this.allGroups$,
            groupId: this.groupId,
            bulkRemoveAssetsFromGroup: this.assetDataService.bulkRemoveAssetsFromGroup.bind(this),
            clearSelectedAssets: this.clearAllSelectedAssets.bind(this),
            division: this.division,
            divisionGroups$: this.divisionGroups$,
            notDivisionGroups$: this.notDivisionGroups$,
            fields: [groupField],
            franchise: this.franchise,
            franchiseGroups$: this.franchiseGroups$,
            notFranchiseGroups$: this.notFranchiseGroups$,
            modalText: `Are you sure you want to remove ${this.selectedAssets.size} ${pluralize('assets', this.selectedAssets.size)} from this group?`,
            models,
            studioId: this.currentStudioId
        };
        this.dialog.open(BulkModalComponent, { data }).afterClosed().pipe(take(1)).subscribe(didUpdate => {
            if (didUpdate) {
                this.onListAssetsAndFilters();
                this.assetUpdated.emit();
            }
        });
    }

    removeAssetsFromSubGroups() {
        const models = this.getShowingAssets().filter(asset => this.selectedAssets.has(asset.id));
        const groupField = new Field(STANDARD_FIELDS.sub_group_ids);
        const data: BulkModalData = {
            action: BULK_MODAL_ACTIONS.REMOVE,
            allGroups$: this.allGroups$,
            subGroupId: this.subGroupId,
            bulkRemoveAssetsFromSubGroup: this.assetDataService.bulkRemoveAssetsFromSubGroup.bind(this),
            clearSelectedAssets: this.clearAllSelectedAssets.bind(this),
            division: this.division,
            divisionGroups$: this.divisionGroups$,
            notDivisionGroups$: this.notDivisionGroups$,
            fields: [groupField],
            franchise: this.franchise,
            franchiseGroups$: this.franchiseGroups$,
            notFranchiseGroups$: this.notFranchiseGroups$,
            modalText: `Are you sure you want to remove ${this.selectedAssets.size} ${pluralize('assets', this.selectedAssets.size)} from this Subgroup?`,
            models,
            studioId: this.currentStudioId
        };
        this.dialog.open(BulkModalComponent, { data }).afterClosed().pipe(take(1)).subscribe(didUpdate => {
            if (didUpdate) {
                this.onListAssetsAndFilters();
                this.updateAssetCountForSubGroups.emit();
            }
        });
    }

    openCustomFieldModal() {
        let assets = this.getShowingAssets().filter(asset => this.selectedAssets.has(asset.id));
        let numOfDivisionAssets: number;
        let numOfFranchiseAssets: number;
        if (this.isFranchiseTable || this.isFranchiseGroupTable || this.isFranchiseSubGroupTable) {
            numOfDivisionAssets = assets.filter(a => a.division_id !== null).length;
            numOfFranchiseAssets = assets.filter(a => a.division_id === null).length;
            assets = assets.filter(a => a.division_id === null);
        }
        if (this.isDivisionTable || this.isEventTable || this.isDivisionGroupTable || this.isDivisionSubGroupTable) {
            numOfDivisionAssets = assets.filter(a => a.division_id === null).length;
            numOfFranchiseAssets = assets.filter(a => a.division_id !== null).length;
        }
        //const deptIds = new Set(assets.map(a => a.department_id));
        const visibilityType = this.tableType === TableTypes.TransactionTable ? FieldVisibility.Transaction
            : this.tableType === TableTypes.DivisionTable ? FieldVisibility.Division
                : this.tableType === TableTypes.FranchiseTable ? FieldVisibility.Franchise : FieldVisibility.All;
        const BASE_FIELDS = new Set(['id', 'franchise_id', 'sync_id', 'photos', 'attachments', 'original_data', 'import_payload', 'is_split', 'displayFields', 'created_by', 'created_at', 'history', 'updated_by', 'project_id', 'studio_id', 'department_id', 'disposition_id', 'division_id', 'warehouse_id', 'warehouse_location_id', 'warehouse_sub_location_id', 'storage_box_id', 'status_id', 'location_id', 'trashed', 'for_review', 'updated_at', 'origin_currency', 'character_id', 'set_id', 'sub_location_id', 'sub_department_id', 'group_ids', 'qty_on_hand', 'sub_code', 'assetEvents', 'free_field_1', 'free_field_2', 'free_field_3', 'created_by_user', 'last_updated_by']);
        const fieldsForUpdate = this.fields.filter(field => !BASE_FIELDS.has(field.canonical_name) && (field.visibility === FieldVisibility.All || field.visibility === visibilityType) && (((field.picklistOptions && field.picklistOptions.length)) || field.type === FIELD_TYPES.SHORT_TEXT_AREA.type || field.type === FIELD_TYPES.LONG_TEXT_AREA.type || field.type === FIELD_TYPES.CURRENCY.type || field.type === FIELD_TYPES.NUMBER.type || field.type === FIELD_TYPES.CHECKBOX.type));
        if (fieldsForUpdate.length) {
            const data: UpdateFieldModalData = {
                bulkUpdate: this.assetDataService.bulkUpdateAssets.bind(this),
                fields: fieldsForUpdate,
                fieldOptions: buildPDropdownOptions(fieldsForUpdate, {
                    nullOption: true,
                    nullLabel: 'Field'
                }),
                assets,
                numOfDivisionAssets,
                numOfFranchiseAssets
            };
            this.dialog.open(UpdateFieldModalComponent, { data }).afterClosed().pipe(take(1)).subscribe(didUpdate => {
                let updatedAssteount = 0;
                if (didUpdate) {
                    this.store.select(fromRoot.getUpdatedFieldAssetCount)
                        .subscribe(function(count) {
                            updatedAssteount = count;
                        });
                    if (!this.isTransactionTable) {
                        const messageUpdated = `${updatedAssteount} asset${updatedAssteount === 1 ? '' : 's'} successfully updated. `;
                        const updateFieldMessage = this.isRequestTable ? `${assets.length} ${pluralize('asset', assets.length)} successfully updated. ` : messageUpdated;
                        this.store.dispatch(new layoutActions.InfoAction({ message: updateFieldMessage }));
                    }
                    this.onListAssetsAndFilters();
                }
            });
        } else {
            this.dialog.open(ConfirmModalComponent, {
                data: {
                    title: '',
                    message: 'There are no fields available to update for the selected assets. Try selecting assets in one department.',
                    allowCancel: false
                }
            });
        }
    }

    openRequestAssetsModal() {
        const data: AddToRequestModalData = {
            assetIds: this.getShowingAssets().filter(asset => this.selectedAssets.has(asset.id)).map(a => a.id),
            clearSelectedAssets: this.clearAllSelectedAssets.bind(this),
            studioId: this.currentStudioId
        };
        this.dialog.open(AddToRequestModalComponent, { data, width: '750px', maxWidth: '80vw' });
    }

    bulkMoveAsset() {
        const assets = this.getShowingAssets().filter(asset => this.selectedAssets.has(asset.id));
        if (assets.length > 0) {
            const assetsIdToTrash = assets.map(a => a.id);
            const studioId = assets[0].studio_id;
            const assetMutations = { trashed: true };

            this.isLoading = true;
            this.store.dispatch(new assetActions.UpdateMultipleAction({ assetIdList: assetsIdToTrash, studioId, assetMutations }));
            this.store.select(fromRoot.getAssetSaving).pipe(
                filter(saving => saving !== ActionStatus.Loading),
                take(1))
                .subscribe((saving) => {
                    if (saving === ActionStatus.Complete) {
                        this.store.dispatch(new layoutActions.InfoAction({ message: `${assetsIdToTrash.length} ${pluralize('Asset', assetsIdToTrash.length)} ${assetsIdToTrash.length > 1 ? 'have' : 'has'} been moved to Trash successfully.` }));
                        this.clearAllSelectedAssets();
                        this.onListAssetsAndFilters();
                    } else if (saving === ActionStatus.Failed) {
                        this.isLoading = false;
                    }
                });
            this.assetUpdated.emit();
        }
    }
    openStatusModal() {
        const assets = this.getShowingAssets().filter(asset => this.selectedAssets.has(asset.id));
        const numOfNonDivisionAssets = assets.filter(a => a.division_id === null);
        let numOfDivisionAssets: number;
        if (this.isDivisionTable || this.isDivisionGroupTable || this.isDivisionSubGroupTable || this.isEventTable) {
            numOfDivisionAssets = assets.filter(a => a.division_id !== null).length;
        }
        const data: BulkModalData = {
            action: BULK_MODAL_ACTIONS.STATUS,
            bulkUpdate: this.assetDataService.bulkUpdateAssets.bind(this),
            fields: getBulkFields(this.fields, ['status_id']),
            models: assets,
            statuses: this.statuses$,
            numOfNonDivisionAssets: numOfNonDivisionAssets.length,
            numOfDivisionAssets
        };
        this.dialog.open(BulkModalComponent, { data }).afterClosed().pipe(take(1)).subscribe(didUpdate => {
            if (didUpdate) {
                const messageUpdated = numOfDivisionAssets > 0 ? `${numOfDivisionAssets} asset${numOfDivisionAssets === 1 ? '' : 's'} successfully updated. ` : '';
                const messageNotUpdated = numOfNonDivisionAssets.length > 0 ? `${numOfNonDivisionAssets.length} asset${numOfNonDivisionAssets.length === 1 ? ' was' : 's were'} not updated.` : '';
                this.store.dispatch(new layoutActions.InfoAction({ message: messageUpdated + messageNotUpdated }));
                this.onListAssetsAndFilters();
            }
        });
    }

    openExcludedDispositionModal() {
        const models = this.isTransactionTable ? this.getShowingTransactions().filter((trans) => this.selectedTransactions.has(trans.id)) : this.getShowingAssets().filter(asset => this.selectedAssets.has(asset.id));
        const bulkSave = this.isTransactionTable ? this.bulkSaveTransactions.bind(this) : this.assetDataService.bulkSaveAssets.bind(this);
        const bulkUpdate = this.isTransactionTable ? this.bulkSaveTransactions.bind(this) : this.assetDataService.bulkUpdateAssets.bind(this);

        this.dialog.open(BulkModalComponent, {
            data: {
                action: BULK_MODAL_ACTIONS.EXCLUDED_DISPOSITION,
                models,
                bulkSave,
                bulkUpdate,
                excludedDispositions: this.excludedDispositions$,
                fields: getBulkFields(this.fields, [this.indexType === AssetIndexTypes.Excluded ? 'excluded_disposition_id' : 'disposition_id']),
                isTransactionUpdate: this.isTransactionTable,
                confirm: false
            }
        }).afterClosed().pipe(take(1)).subscribe(didUpdate => {
            if (didUpdate) {
                this.onListAssetsAndFilters();
            }
        });
    }
    openDispositionModal() {
        let models = [];
        if (!this.isTransactionTable) {
            const dispositionField = this.fields.find(field => field.canonical_name === 'disposition_id');
            if (dispositionField.visibility === FieldVisibility.All) {
                models = this.getShowingAssets().filter(asset => this.selectedAssets.has(asset.id));
            } else {
                if (dispositionField.visibility === FieldVisibility.Franchise) {
                    models = this.getShowingAssets().filter(asset => this.selectedAssets.has(asset.id) && asset.division_id === null);
                } else {
                    models = this.getShowingAssets().filter(asset => this.selectedAssets.has(asset.id) && asset.division_id !== null);
                }
            }
        } else {
            models = this.getShowingTransactions().filter((trans) => this.selectedTransactions.has(trans.id))
        }
        const bulkSave = this.isTransactionTable ? this.bulkSaveTransactions.bind(this) : this.assetDataService.bulkSaveAssets.bind(this);
        const bulkUpdate = this.isTransactionTable ? this.bulkSaveTransactions.bind(this) : this.assetDataService.bulkUpdateAssets.bind(this);
        let numOfDivisionAssets: number;
        let numOfFranchiseAssets: number;
        if (!this.isTransactionTable) {
            const assets = this.getShowingAssets().filter(asset => this.selectedAssets.has(asset.id));
            numOfDivisionAssets = assets.filter(a => a.division_id !== null).length;
            numOfFranchiseAssets = assets.filter(a => a.division_id === null).length;
            if (models.length === 0) {
                this.store.dispatch(new layoutActions.ErrorAction({ error: { error: new Error(`Disposition is not available for ${numOfDivisionAssets + numOfFranchiseAssets} Asset(s) and cannot be updated.`) } }));
                return;
            }
        }
        this.dialog.open(BulkModalComponent, {
            data: {
                action: BULK_MODAL_ACTIONS.DISPOSITION,
                models,
                bulkSave,
                bulkUpdate,
                dispositions: this.dispositions$,
                excludedDispositions: this.excludedDispositions$,
                fields: getBulkFields(this.fields, [this.indexType === AssetIndexTypes.Excluded ? 'excluded_disposition_id' : 'disposition_id']),
                isTransactionUpdate: this.isTransactionTable,
                numOfDivisionAssets,
                numOfFranchiseAssets,
                confirm: false
            }
        }).afterClosed().pipe(take(1)).subscribe(didUpdate => {
            let updatedAssetCount = 0;
            const selectedAssetCount = numOfDivisionAssets + numOfFranchiseAssets;
            if (didUpdate) {
                if (!this.isTransactionTable) {
                    this.store.select(fromRoot.getUpdatedFieldAssetCount)
                        .subscribe(function(count) {
                            updatedAssetCount = count;
                        });

                    const messageUpdated = updatedAssetCount > 0 ? `${updatedAssetCount} Asset(s) successfully updated.` : '';
                    const messageNotUpdated = (selectedAssetCount - updatedAssetCount) > 0 ? ` Disposition is not available for ${(selectedAssetCount - updatedAssetCount)} Asset(s) and cannot be updated.` : '';
                    if (updatedAssetCount > 0) {
                        this.store.dispatch(new layoutActions.InfoAction({ message: messageUpdated + messageNotUpdated }));
                    } else {
                        this.store.dispatch(new layoutActions.ErrorAction({ error: { error: new Error(messageNotUpdated) } }));
                    }
                }
                this.onListAssetsAndFilters();
            }
        });
    }

    openChooseColumnModal() {
        const data: MobileColumnModalData = {
            allFieldOptions: this.allFieldOptions,
            selectedFields: this.selectedFields,
            selectedFieldOptions: this.selectedFieldOptions,
            tableType: this.tableType
        };
        const config: MatDialogConfig = {
            data,
            autoFocus: true,
        };
        this.dialog.open(MobileColumnModalComponent, config);
    }

    openTransferToEventModal() {
        let assetEvents = [];

        this.selectedAssets.forEach(id => {
            assetEvents.push(this.assetEventForAssetIds[id]);
        });
        const eventField = new Field(FAKE_EVENT_FIELD);
        const data: BulkModalData = {
            action: BULK_MODAL_ACTIONS.TRANSFER,
            transferAssetsToEvent: this.assetDataService.transferAssetsToEvent.bind(this),
            clearSelectedAssets: this.clearAllSelectedAssets.bind(this),
            fields: [eventField],
            models: assetEvents,
            sourceEventId: this.sourceEventId,
            events: this.events$.pipe(map(ev => ev.filter(item => item.id != this.event.id)))
        };
        this.dialog.open(BulkModalComponent, { data }).afterClosed().pipe(take(1)).subscribe(didUpdate => {
            let nonUpdateAsset = 0;
            let messageUpdated = "";
            if (didUpdate) {
                this.store.select(fromRoot.getNonTransferAssets).subscribe(event => {
                    nonUpdateAsset = event.length;
                })
                if (nonUpdateAsset === assetEvents.length) {
                    messageUpdated = `Selected asset(s) already exist in the event and will not be moved.`
                } else if (nonUpdateAsset === 0) {
                    messageUpdated = `${assetEvents.length} asset(s) successfully transferred.`
                } else {
                    const lenght = assetEvents.length - nonUpdateAsset;
                    messageUpdated = `${nonUpdateAsset} assets already exist in the event, so only the remaining ${lenght} of the selected assets will transfer.`
                }
                this.store.dispatch(new layoutActions.InfoAction({ message: messageUpdated }));
                this.onListAssetsAndFilters();
            }
        });
    }

    bulkSaveTransactions(transactions, dialogRef, properties) {
        const toBecomeAssets: { id: number, cost: string }[] = [];
        const toStayTransactions = [];
        this.departmentList.pipe(take(1)).subscribe(depts => {
            let invalid: boolean;
            let department: Department;
            transactions.forEach(t => {
                if (t.excluded) {
                    toStayTransactions.push(t);
                    return;
                }
                department = depts.find(dep => dep.id === t.department_id);
                if (department) {
                    const fieldsWithDeptFields = this.transactionFormService.buildWithDeptFields(department, this.fields);
                    invalid = fieldsWithDeptFields.some(field => {
                        return field.departmentField.required && !t[field.field.canonical_name];
                    });
                    if (invalid) {
                        toStayTransactions.push(t);
                    } else {
                        toBecomeAssets.push({ id: t.id, cost: t.allCosts[t.origin_currency] });
                        this.store.dispatch(new transactionActions.RemoveAction({ franchiseId: t.franchise_id, transactionIds: [t.id], isExcluded: t.excluded }));
                    }
                }
            });

            // Pass this along so we don't call it until save is done
            let message = `${toBecomeAssets.length} ${pluralize('Asset', toBecomeAssets.length)} ${pluralize('has', toBecomeAssets.length)} been created.`;
            if (toStayTransactions.length) {
                message = `${pluralize('Transaction', toStayTransactions.length)} updated.`;
            }
            const infoAction = new layoutActions.InfoAction({ message });

            if (toStayTransactions.length) {
                this.transactionDataService.bulkSaveTransactions(toStayTransactions, dialogRef, infoAction);
            }
            if (toBecomeAssets.length) {
                this.assetDataService.ceateAssetsFromTransactions(toBecomeAssets, properties, dialogRef, { infoAction }, null, this.dialog);
            }
        });
    }

    openAddPhotosModal(asset?: Asset) {
        let models: Asset[] = [];
        if (asset) {
            models = [asset];
        } else {
            models = this.getShowingAssets().filter(asset => this.selectedAssets.has(asset.id));
        }
        const dialogRef = this.dialog.open(PhotoUploadModalComponent, {
            data: {
                assets: models
            }
        });
        dialogRef.afterClosed().pipe(take(1)).subscribe(photos => {
            this.photosUploaded(photos, models);
            this.onListAssetsAndFilters();
        });
    }

    openAddAttachmentModal() {
        let models = this.getShowingAssets().filter(asset => this.selectedAssets.has(asset.id));

        const dialogRef = this.dialog.open(AttachmentUploadModalComponent, {
            data: { owner: models, uploadUrl: "/api/attachments", uploadMultiple: true }
        })
        dialogRef.afterClosed().pipe(take(1)).subscribe(attachments => {
            if (attachments && attachments.length) {
                const message = `${attachments.length} attachment${attachments.length > 1 ? 's ' : ' '}successfully added${this.selectedAssets.size > 1 ? ' to ' + this.selectedAssets.size + ' Assets.' : '.'}`;
                for (let asset of models) {
                    for (let attachment of attachments) {
                        this.attServ.add({ id: asset.id, attachment });
                    }
                }
                this.store.dispatch(new layoutActions.InfoAction({ message }));
                this.onListAssetsAndFilters();
            }
            this.clearAllSelectedAssets()
        })
    }

    photosUploaded(photos: Photo[], assets: Asset[]) {
        if (photos) {
            this.store.dispatch(new assetActions.AddPhotosAction({ assets: assets.map(asset => asset.id), photos: photos }));
        }
    }

    getAssetModelFromTransaction(transaction, fieldsWithDeptFields) {
        let assetObj;
        if (transaction.department_id) {
            assetObj = {};
            for (const fieldId in fieldsWithDeptFields) {
                if (fieldsWithDeptFields.hasOwnProperty(fieldId)) {
                    const fieldWithDeptField = fieldsWithDeptFields[fieldId];
                    assetObj[fieldWithDeptField.field.canonical_name] = fieldWithDeptField.field.getValueFromAsset(transaction);
                }
            }
            assetObj = {
                ...assetObj,
                transactions: {},
                project_id: transaction.project_id,
                studio_id: this.currentStudioId,
                franchise_id: this.franchise.id,
            };
            assetObj.transactions[transaction.id] = transaction;
            return new Asset(assetObj);
        }
    }

    expandRow(transaction: Transaction) {
        // Expando row only shows for unreconciled view in the default tab and always in the excluded tab
        if (this.currentView === this.assetIndexTypes.Default && this.transactionTypesShown === TransactionTypes.Unreconciled || this.currentView !== this.assetIndexTypes.Default) {
            this.store.dispatch(new transactionActions.SelectAction(transaction.id));

            if (Object.keys(this.expandedItems).includes(transaction.id.toString())) {
                // The row which is currently expanded was clicked, so we close it
                this.expandedItems = {};
            } else {
                this.expandedItems = { [transaction.id]: true };
            }
        }
    }

    openMoveModal() {
        if (this.selectedAssets.size > 1000) {
            this.dialog.open(ConfirmModalComponent, {
                data: {
                    allowCancel: false,
                    message: `1,000 asset limit exceeded. Please select 1,000 or fewer assets to perform this action.`,
                    confirmButton: 'Confirm'
                }
            });
        } else {
            this.bulkMoveModalDataService.dispatchData();
            this.bulkMoveModalDataService.openModal(this.dialog, this.getShowingAssets().filter(asset => this.selectedAssets.has(asset.id)), this.user, this.assetDataService.checkAndSaveAssets.bind(this), this.clearAllSelectedAssets.bind(this), this.onListAssetsAndFilters.bind(this, { indexType: this.indexType }), this.tableType);
        }
    }

    openMoveFranchiseInfoModal() {
        this.bulkMoveModalDataService.dispatchData();
        this.bulkMoveModalDataService.openFranchiseInfoModal(this.dialog, this.getShowingAssets().filter(asset => this.selectedAssets.has(asset.id)), this.user, this.assetDataService.checkAndSaveAssets.bind(this), this.clearAllSelectedAssets.bind(this), this.onListAssetsAndFilters.bind(this, { indexType: this.indexType }), this.tableType, `Update ${this.customFieldNames.franchise_id}/${this.customFieldNames.series_id}`);
    }

    openDepartmentModal() {
        const models = this.isTransactionTable ? this.getShowingTransactions().filter((trans) => this.selectedTransactions.has(trans.id)) : this.getShowingAssets().filter(asset => this.selectedAssets.has(asset.id));
        const bulkSave = this.isTransactionTable ? this.bulkSaveTransactions.bind(this) : this.assetDataService.bulkSaveAssets.bind(this);
        const bulkUpdate = this.isTransactionTable ? this.bulkSaveTransactions.bind(this) : this.assetDataService.bulkUpdateAssets.bind(this);
        let assets = this.getShowingAssets().filter(asset => this.selectedAssets.has(asset.id));
        let numOfDivisionAssets: number;
        let numOfFranchiseAssets: number;
        if (this.isFranchiseTable || this.isFranchiseGroupTable || this.isFranchiseSubGroupTable) {
            numOfDivisionAssets = assets.filter(a => a.division_id !== null).length;
            numOfFranchiseAssets = assets.filter(a => a.division_id === null).length;
            assets = assets.filter(a => a.division_id === null);
        }
        if (this.isDivisionTable || this.isEventTable || this.isDivisionGroupTable || this.isDivisionSubGroupTable) {
            numOfDivisionAssets = assets.filter(a => a.division_id === null).length;
            numOfFranchiseAssets = assets.filter(a => a.division_id !== null).length;
        }
        this.dialog.open(BulkModalComponent, {
            data: {
                action: BULK_MODAL_ACTIONS.DEPARTMENT,
                models,
                bulkSave,
                bulkUpdate,
                departments: this.departmentList,
                fields: getBulkFields(this.fields, ['department_id', 'sub_department_id']),
                isTransactionUpdate: this.isTransactionTable,
                confirm: false
            }
        }).afterClosed().pipe(take(1)).subscribe(didUpdate => {
            if (didUpdate) {
                if (!this.isTransactionTable) {
                    const messageUpdated = numOfFranchiseAssets > 0 ? `${numOfFranchiseAssets} asset${numOfFranchiseAssets === 1 ? '' : 's'} successfully updated. ` : '';
                    const messageNotUpdated = numOfDivisionAssets > 0 ? `${numOfDivisionAssets} asset${numOfDivisionAssets === 1 ? ' was' : 's were'} not updated.` : '';
                    const updateFieldMessage = this.isRequestTable ? `${assets.length} ${pluralize('asset', assets.length)} successfully updated. ` : (messageUpdated + messageNotUpdated);
                    this.store.dispatch(new layoutActions.InfoAction({ message: updateFieldMessage }));
                }
                this.onListAssetsAndFilters();
            }
        });
    }

    getInitialDateMin(filters, canonicalName) {
        setTimeout(() => {
            if (filters && canonicalName && filters[canonicalName] && filters[canonicalName].value[0]) {
                this.dateFiltersMin[canonicalName] = new Date(filters[canonicalName].value[0]);
            } else {
                this.dateFiltersMin[canonicalName] = null;
            }
        }, 0);
    }

    getInitialDateMax(filters, canonicalName) {
        setTimeout(() => {
            if (filters && canonicalName && filters[canonicalName] && filters[canonicalName].value[1]) {
                this.dateFiltersMax[canonicalName] = new Date(filters[canonicalName].value[1]);
            } else {
                this.dateFiltersMax[canonicalName] = null;
            }
        }, 0);
    }

    createAssetReport(singlePage) {

        let assetLimit = "250"
        let assetLimitSize = 250


        let transactionMessage = [`${assetLimit} asset limit exceeded. Please select ${assetLimit} or fewer assets to perform this action.`];
        transactionMessage.push('If you would rather not run your report in batches, you can export full selection to CSV.')
        if (this.selectedAssets.size > assetLimitSize) {
            this.dialog.open(ConfirmModalComponent, {
                data: {
                    allowCancel: false,
                    transactionMessage,
                    confirmButton: 'Confirm'
                }
            });
        } else {
            this.dialog.open(ConfirmModalComponent, {
                data: {
                    onConfirm: this.confirmCreateAssetReport.bind(this, singlePage),
                    message: `Generate PDF report for ${this.selectedTransactions.size || this.selectedAssets.size} selected assets?`,
                    confirmButton: 'Confirm',
                    warningMessage: (this.selectedTransactions.size || this.selectedAssets.size) >= assetLimitSize ? [`WARNING: Reports with more than ${assetLimit} assets may take a few minutes. Please be patient.`] : ''
                }
            });
        }
    }

    confirmCreateAssetReport(singlePage, dialogRef) {
        dialogRef.close(true);
        const assets: Asset[] = this.getShowingAssets().filter(asset => this.selectedAssets.has(asset.id));
        const assetIds: number[] = assets.map(a => a.id);
        const fields: string[] = this.selectedFields.map(field => field.canonical_name);
        const sortObject: SortObject = (this.latestSortObject && this.latestSortObject.field) ? Object.assign({}, this.latestSortObject) : null;
        if (sortObject && sortObject.field) {
            sortObject.field = sortObject.field === STANDARD_FIELDS.cost.canonical_name ? 'displayFields.cost' : sortObject.field;
        }
        this.store.dispatch(new layoutActions.InfoAction({ message: 'Creating asset report, file will download when complete.' }));
        if (this.isDivisionTable || this.isDivisionGroupTable || this.isDivisionSubGroupTable) {
            this.store.dispatch(new reportActions.CreateDivisionAction({ division_id: this.division.id, entities: assetIds, included_fields: fields, sort: sortObject, singlePage }));
        } else if (this.isRequestTable) {
            this.addRequestSpecificColumns(fields, false);
            this.store.dispatch(new reportActions.CreateRequestAction({ studio_id: this.currentStudioId, request_id: this.request.id, requestType: this.requestType, entities: assetIds, included_fields: fields, sort: sortObject, singlePage }));
        } else if (this.isEventTable) {
            this.addEventSpecificColumns(fields, false);
            this.store.dispatch(new reportActions.CreateEventAction({ division_id: this.division.id, event_id: this.event.id, entities: assetIds, included_fields: fields, sort: sortObject, singlePage }));
        } else if (this.tableType === TableTypes.StudioTable || this.tableType === TableTypes.StudioGroupTable || this.tableType === TableTypes.StudioSubGroupTable) {
            this.store.dispatch(new reportActions.CreateAction({ studio_id: this.currentStudioId, entities: assetIds, included_fields: fields, sort: sortObject, other_currency_id: this.selectedProjectCurrencyId, singlePage }));
        } else {
            if (this.selectedProjectIdsList.length > 1) {
                const otherCostIndex = fields.findIndex(name => name === 'other_cost');
                if (otherCostIndex > -1) {
                    fields.splice(otherCostIndex, 1);
                }
            }
            this.store.dispatch(new reportActions.CreateAction({ franchise_id: this.franchise.id, entities: assetIds, included_fields: fields, sort: sortObject, other_currency_id: this.selectedProjectCurrencyId, singlePage }));
        }
    }

    createAssetFromTrx() {
        const transactions = this.getShowingTransactions().filter((trans) => this.selectedTransactions.has(trans.id));
        const isValid = this.checkTrxSameValues(transactions);
        if (isValid) {
            this.store.dispatch(new transactionActions.SelectAction(transactions[0].id));
            const data: CreateAssetFromTrxModalData = {
                characters$: this.characters,
                departments$: this.departmentList,
                dispositions$: this.dispositions$,
                excludedDispositions$: this.excludedDispositions$,
                franchise: this.franchise,
                indexType: this.indexType,
                inputFields: this.fields,
                projects$: this.projectList,
                projectCurrencies$: this.projectCurrencies$,
                locations$: this.locations$,
                sets$: this.sets,
                subDepartments$: this.subDepartments,
                transactions,
            };
            this.dialog.open(CreateAssetFromTrxModalComponent, {
                data
            });
        }
    }

    checkIn() {
        const assets = this.getShowingAssets().filter(asset => this.selectedAssets.has(asset.id));
        const data: CheckInModalData = {
            assetEventsForAssetId: this.assetEventForAssetIds,
            assets,
            eventId: this.event.id
        };

        this.dialog.open(CheckInModalComponent, {
            data
        });
    }

    checkOut() {
        const assets = this.getShowingAssets().filter(asset => this.selectedAssets.has(asset.id));
        const data: CheckOutModalData = {
            assetEventsForAssetId: this.assetEventForAssetIds,
            assets,
            eventId: this.event.id,
            qtyOnHand: this.qtyOnHand
        };

        this.dialog.open(CheckOutModalComponent, {
            data
        });
    }

    openCharacterModal() {
        const models = this.isTransactionTable
            ? this.getShowingTransactions().filter((trans) => this.selectedTransactions.has(trans.id)) as any
            : this.getShowingAssets().filter(asset => this.selectedAssets.has(asset.id)) as any;
        const bulkSave = this.isTransactionTable ? this.bulkSaveTransactions.bind(this) : this.assetDataService.bulkSaveAssets.bind(this);
        const bulkUpdate = this.assetDataService.bulkUpdateAssets.bind(this);

        let numOfCostumeAssets = 0;
        let numOfNonCostumeAssets = 0;
        let franchiseIds = [];
        let franchiseProjectIds = [];

        const field = this.fields.find(field => field.canonical_name === "character_id");
        models.forEach(m => {
            if (m.department_id) {
                const department: Department = this.departments.find(d => d.id === m.department_id);
                const departmentField: DepartmentField = department.departmentFields.find(df => df.field_id === field?.id);
                franchiseIds.push(m.franchise_id);
                franchiseProjectIds.push(m.project_id);
                if (department && departmentField) {
                    numOfCostumeAssets++;
                } else {
                    numOfNonCostumeAssets++;
                }
            }
        });
        const uniqueFranchiseIds = [...new Set(franchiseIds)];
        const uniqueProjectIds = [...new Set(franchiseProjectIds)];
        const nullFranchiseIds = uniqueFranchiseIds.find(val => val === null);

        if (this.isDivisionTable && uniqueProjectIds[0] !== null && numOfNonCostumeAssets === 0) {
            this.store.dispatch(new characterActions.ListByProjectAction({ projectId: uniqueProjectIds[0], divisionId: this.division.id }));
            this.divisionChar$ = this.store.select(characterSelectors.getCharactersWithProjectCharacters).pipe(filter(char => !!char))
        }

        const data = {
            action: BULK_MODAL_ACTIONS.CHARACTER,
            bulkSave,
            bulkUpdate,
            fields: getBulkFields(this.fields, ['character_id']),
            characters: this.isDivisionTable ? this.divisionChar$ : this.bulkModalCharacters$,
            isTransactionUpdate: this.isTransactionTable,
            models,
            confirm: false,
        };
        const ifFranchiseTable = {
            clearSelectedCharacter: this.clearSelectedCharacter.bind(this),
            selectCharacter: this.selectCharacter.bind(this)
        };
        const allData = this.isFranchiseTable ? { ...data, ...ifFranchiseTable } : data;

        if (this.isDivisionTable && ((nullFranchiseIds === null) || uniqueFranchiseIds.length !== 1 || uniqueProjectIds.length !== 1)) {
            const message = ['All selected Assets must be in the same Series/Feature and Project in order to bulk update Character/Set.',
                'If needed, first use the Add/Update > Features/Series bulk option to move the Assets into the same Feature/Series and Project'];
            this.openConfirmModal(message);
        } else if (numOfNonCostumeAssets > 0) {
            const message = ['One or more selected Assets belong to a Department which does not allow updates to the Character/Set field.',
                'If needed, first use the Add/ Update > Department bulk option to move the Assets into the correct Department']
            this.openConfirmModal(message);
        } else {
            this.dialog.open(BulkModalComponent, {
                data: allData
            }).afterClosed().pipe(take(1)).subscribe(didUpdate => {
                if (didUpdate) {
                    const messageUpdated = numOfCostumeAssets > 0
                        ? `${numOfCostumeAssets} ${pluralize(this.isTransactionTable ? 'transaction' : 'asset', numOfCostumeAssets)} successfully updated. `
                        : '';
                    this.store.dispatch(new layoutActions.InfoAction({ message: messageUpdated }));
                    this.onListAssetsAndFilters();
                }
            });
        }
    }

    openSetModal() {
        const models = this.isTransactionTable
            ? this.getShowingTransactions().filter((trans) => this.selectedTransactions.has(trans.id)) as any
            : this.getShowingAssets().filter(asset => this.selectedAssets.has(asset.id)) as any;
        const bulkSave = this.isTransactionTable ? this.bulkSaveTransactions.bind(this) : this.assetDataService.bulkSaveAssets.bind(this);
        const bulkUpdate = this.assetDataService.bulkUpdateAssets.bind(this);

        const ifFranchiseTable = {
            clearSelectedSet: this.clearSelectedSet.bind(this),
            selectSet: this.selectSet.bind(this)
        };
        let numOfSetAssets = 0;
        let numOfNonSetAssets = 0;
        let franchiseIds = [];
        let franchiseProjectIds = [];

        const field = this.fields.find(field => field.canonical_name === "set_id");
        models.forEach(m => {
            if (m.department_id) {
                const department: Department = this.departments.find(d => d.id === m.department_id);
                const departmentField: DepartmentField = department.departmentFields.find(df => df.field_id === field?.id);
                franchiseIds.push(m.franchise_id);
                franchiseProjectIds.push(m.project_id);
                if (department && departmentField) {
                    numOfSetAssets++;
                } else {
                    numOfNonSetAssets++;
                }
            }
        });
        const uniqueFranchiseIds = [...new Set(franchiseIds)];
        const uniqueProjectIds = [...new Set(franchiseProjectIds)];
        const nullFranchiseIds = uniqueFranchiseIds.find(val => val === null);
        if (this.isDivisionTable && uniqueProjectIds[0] !== null && numOfNonSetAssets === 0) {
            this.store.dispatch(new setActions.ListSetAction({ projectId: uniqueProjectIds[0], divisionId: this.division.id }));
            this.divisionSet$ = this.store.select(setSelectors.getSetsWithProjectSets).pipe(filter(sets => !!sets))
        }
        const data = {
            action: BULK_MODAL_ACTIONS.SET,
            bulkSave,
            bulkUpdate,
            fields: getBulkFields(this.fields, ['set_id']),
            sets: this.isDivisionTable ? this.divisionSet$ : this.bulkModalSets$,
            isTransactionUpdate: this.isTransactionTable,
            models,
            confirm: false,
        };

        const allData = this.isFranchiseTable ? { ...data, ...ifFranchiseTable } : data;

        if (this.isDivisionTable && ((nullFranchiseIds === null) || uniqueFranchiseIds.length !== 1 || uniqueProjectIds.length !== 1)) {
            const message = ['All selected Assets must be in the same Series/Feature and Project in order to bulk update Character/Set.',
                'If needed, first use the Add/Update > Features/Series bulk option to move the Assets into the same Feature/Series and Project'];
            this.openConfirmModal(message);
        } else if (numOfNonSetAssets > 0) {
            const message = ['One or more selected Assets belong to a Department which does not allow updates to the Character/Set field.',
                'If needed, first use the Add/ Update > Department bulk option to move the Assets into the correct Department']
            this.openConfirmModal(message);
        } else {
            this.dialog.open(BulkModalComponent, {
                data: allData
            }).afterClosed().pipe(take(1)).subscribe(didUpdate => {
                if (didUpdate) {
                    const messageUpdated = numOfSetAssets > 0
                        ? `${numOfSetAssets} ${pluralize(this.isTransactionTable ? 'transaction' : 'asset', numOfSetAssets)} successfully updated. `
                        : '';
                    this.store.dispatch(new layoutActions.InfoAction({ message: messageUpdated }));
                    this.onListAssetsAndFilters();
                }
            });
        }
    }
    openConfirmModal(message) {
        this.dialog.open(ConfirmModalComponent, {
            data: {
                title: 'Warning',
                charSetMessage: message,
                confirmButton: 'Confirm',
                confirmColor: 'primary',
                cancelButton: 'Cancel',
                allowCancel: false
            }
        })
    }
    toggleExcluded() {
        const ts = this.getShowingTransactions();
        const transactions = ts.filter((trans) => this.selectedTransactions.has(trans.id));
        const transactionData: Transaction[] = [];
        transactions.forEach((t) => transactionData.push(new Transaction({ ...t, excluded: !t.excluded })));
        this.store.dispatch(new transactionActions.UpdateMultipleAction({ franchiseId: this.franchise.id, transactions: transactionData }));
        this.store.select(fromRoot.getTransactionSaving).pipe(
            filter(saving => saving !== ActionStatus.Loading),
            take(1))
            .subscribe(saving => {
                if (saving === ActionStatus.Complete) {
                    this.onListAssetsAndFilters();
                }
            });
    }

    clearSelectedCharacter() {
        this.store.dispatch(new assetModalActions.SelectCharacterAction(null));
    }

    clearSelectedSet() {
        this.store.dispatch(new assetModalActions.SelectSetAction(null));
    }

    selectCharacter(characterId: number) {
        this.store.dispatch(new assetModalActions.SelectCharacterAction(characterId));
    }

    selectSet(setId: number) {
        this.store.dispatch(new assetModalActions.SelectSetAction(setId));
    }

    toggleAssets(event?) {
        this.turboTable.first = 0;
        const assetsToShow = event.value;
        this.store.dispatch(new assetActions.SelectAssetsShown(assetsToShow));
        this.clearAllSelectedAssets();
        this.updateBulkOptions(assetsToShow);
        this.displayChanged.emit({ recordIndex: this.turboTable.first, pageSize: this.turboTable.rows });
    }

    toggleTransactions(event?) {
        const transactionsToShow = event.value;
        this.store.dispatch(new transactionActions.SelectTransactionsShown(transactionsToShow));
    }

    onSelectFields($event: { value: number[] }) {
        const selectedFields = $event.value;
        const tableState: TableState = JSON.parse(localStorage.getItem(this.stateKey));
        const addedField = this.getFieldEntity(selectedFields[selectedFields.length - 1]);
        if (!selectedFields.length) {
            return this.store.dispatch(new layoutActions.ErrorAction({
                error: new HttpErrorResponse({ error: new Error('Must select at least 1 column') })
            }));
        }

        if (!this.isTransactionTable) {
            if (addedField && addedField.canonical_name === 'photos') {
                selectedFields.splice(selectedFields.length - 1, 1);
                selectedFields.unshift(addedField.id);
            }
        }

        // Update tableState.columnOrder when a field is added
        // TT saves state in a number of cases, but not when columns change
        if (addedField && addedField.canonical_name && tableState && tableState.columnOrder && !tableState.columnOrder.includes(`displayFields.${addedField.canonical_name}`)) {
            tableState.columnOrder.push(`displayFields.${addedField.canonical_name}`);
            this.saveTableState(tableState);
        }

        this.checkForAndHandleColumnHiding(selectedFields, tableState);

        if (this.isTransactionTable) {
            if (this.indexType === AssetIndexTypes.Excluded) {
                return this.store.dispatch(new fieldActions.SaveExcludedTransactionSelectedAction(selectedFields));
            } else {
                return this.store.dispatch(new fieldActions.SaveTransactionSelectedAction(selectedFields));
            }
        } else if (this.isDivisionTable) {
            return this.store.dispatch(new fieldActions.SaveDivisionAssetSelectedAction(selectedFields));
        } else if (this.isEventTable) {
            return this.store.dispatch(new fieldActions.SaveEventAssetSelectedAction(selectedFields));
        } else if (this.isFranchiseTable) {
            return this.store.dispatch(new fieldActions.SaveAssetSelectedAction(selectedFields));
        } else if (this.isFranchiseGroupTable) {
            return this.store.dispatch(new fieldActions.SaveFranchiseGroupAssetSelectedAction(selectedFields));
        } else if (this.isDivisionGroupTable) {
            return this.store.dispatch(new fieldActions.SaveDivisionGroupAssetSelectedAction(selectedFields));
        } else if (this.isRequestTable) {
            return this.store.dispatch(new fieldActions.SaveRequestAssetSelectedAction(selectedFields));
        } else if (this.isTransactionMatchTable) {
            return this.store.dispatch(new fieldActions.SaveMatchAssetSelectedAction(selectedFields));
        } else if (this.isTransactionMatchReviewTable) {
            return this.store.dispatch(new fieldActions.SaveMatchReviewSelectedAction(selectedFields));
        } else if (this.tableType === TableTypes.StudioTable) {
            return this.store.dispatch(new fieldActions.SaveStudioSelectedAction(selectedFields));
        } else if (this.tableType === TableTypes.StudioGroupTable) {
            return this.store.dispatch(new fieldActions.SaveStudioGroupAssetSelectedAction(selectedFields))
        } else if (this.tableType === TableTypes.StudioSubGroupTable) {
            return this.store.dispatch(new fieldActions.SaveStudioSubGroupAssetSelectedAction(selectedFields))
        } else if (this.isFranchiseSubGroupTable) {
            return this.store.dispatch(new fieldActions.SaveFranchiseSubGroupAssetSelectedAction(selectedFields));
        } else if (this.isDivisionSubGroupTable) {
            return this.store.dispatch(new fieldActions.SaveDivisionSubGroupAssetSelectedAction(selectedFields));
        }
    }

    /**
     * If a column is hidden, make sure its filter is properly removed
     * @param selectedFields
     */
    checkForAndHandleColumnHiding(selectedFields: number[], tableState: TableState) {
        let removedFieldId: number[];
        if (this.tableType === TableTypes.TransactionTable && this.indexType === AssetIndexTypes.Excluded) {
            removedFieldId = difference(this.selectedExcludedFieldOptions, selectedFields);
        } else {
            removedFieldId = difference(this.selectedFieldOptions, selectedFields);
        }

        if (removedFieldId && removedFieldId.length) {
            const removedField = this.getFieldEntity(removedFieldId[0]);

            if (!removedField) {
                return;
            }

            // Update tableState.columnOrder when a field is removed
            // If a field is in it but not in selectedFields an error occurs
            if (tableState && tableState.columnOrder) {
                tableState.columnOrder = tableState.columnOrder.filter(col => col !== `displayFields.${removedField.canonical_name}`);
                this.saveTableState(tableState);
            }

            if ((this.isFranchiseTable || this.isTransactionTable) && removedField.canonical_name === STANDARD_FIELDS.department.canonical_name) {
                return;
            }

            this.removeColumnFilter(removedField);
        }
    }

    getFieldEntity(fieldId: number) {
        return this.fieldEntities[fieldId];
    }

    onTableSort(event) {
        if (event.field) {
            this.sortTable.emit({ type: this.indexType, sort: { field: event.field, order: event.order } });
            this.clearAllSelectedItems();
        }
    }

    onTableFilter(event) {
        if (this.currentView && this.indexType && this.currentView !== this.indexType) {
            return;
        }
        this.isFiltered = event.filters && !!(Object.keys(event.filters).length !== 0);
        this.clearAllSelectedItems();
    }

    onFilterRequestStatus(value: boolean) {
        const colFilters = { ['requestAssetApproved']: { matchMode: 'contains', value } };

        this.turboTable.restoringFilter = false;
        this.turboTable.first = 0;

        this.filterTableColumns.emit({ type: this.indexType, filters: colFilters });
        this.turboTable.filter(value, 'requestAssetApproved', 'contains');
    }

    onColumnFilter(filterValue: number[] | string | number | string[], field: Field) {
        this.turboTable.restoringFilter = false;
        this.turboTable.first = 0;

        if (this.filterTimeout) {
            clearTimeout(this.filterTimeout);
        }

        if (typeof filterValue === 'string') {
            filterValue = filterValue.trim();
        } else if (Array.isArray(filterValue)) {
            filterValue = (filterValue as Array<string | number>).map(v => typeof v === 'string' ? v.trim() : v) as string[] | number[];
        }

        this.filterTimeout = setTimeout(() => {
            if (field.canonical_name !== 'photos') {
                const colFilters = {};

                const matchMode = this.columnFilterService.getFilterMatchMode(field.type);

                let normalizedFilterValue: any[] = Array.isArray(filterValue) ? filterValue : [filterValue];

                const nullDisabled = this.nullDisabledMap[field.canonical_name] ?? false;
                if (nullDisabled && normalizedFilterValue.includes(null)) {
                    normalizedFilterValue = normalizedFilterValue.filter(val => val !== null);
                    this.store.dispatch(new layoutActions.InfoAction({
                        message: `You can filter by NULL or a value. You cannot select NULL with other options.`
                    }));
                }

                if (field.canonical_name === 'other_cost') {
                    colFilters[field.canonical_name] = { matchMode, value: normalizedFilterValue, selectedProjectCurrencyId: this.selectedProjectCurrencyId };
                } else {
                    if (field.type === 'PICKLIST' || field.type === 'MULTI_PICKLIST') {
                        colFilters[field.canonical_name] = { matchMode, value: normalizedFilterValue };
                    } else {
                        colFilters[field.canonical_name] = { matchMode, value: filterValue };
                    }
                }

                const options = field.canonical_name === this.standardFields?.origin_currency.canonical_name
                    ? this.selectOptions.project_currency_id
                    : this.selectOptions[field.canonical_name];

                const nonNullOptions = options?.filter(opt => opt.value !== null).map(opt => opt.value) || [];
                const isMasterCheckbox = Array.isArray(normalizedFilterValue) && nonNullOptions.length > 0 &&
                    nonNullOptions.every(opt => normalizedFilterValue.includes(opt));

                if (isMasterCheckbox && normalizedFilterValue.includes(null)) {
                    normalizedFilterValue = normalizedFilterValue.filter(val => val !== null);
                    colFilters[field.canonical_name].value = normalizedFilterValue;
                    this.store.dispatch(new layoutActions.InfoAction({
                        message: `You can filter by NULL or a value. You cannot select NULL with other options.`
                    }));
                }

                if (!this.checkNullFilter(colFilters, isMasterCheckbox)) {
                    this.filterTableColumns.emit({ type: this.indexType, filters: this.colFilterValues });
                    return;
                }

                this.filterTableColumns.emit({ type: this.indexType, filters: colFilters });
                this.turboTable.filter(normalizedFilterValue, this.columnFilterService.returnFilterField(field), matchMode);
            }
            this.filterTimeout = null;
        }, 750);
    }

    onFilterPanelShow(fieldKey: string): void {
        const fieldFilter = this.turboTable?.filters?.[fieldKey];
        let currentValue: any[] = [];

        if (Array.isArray(fieldFilter)) {
            currentValue = fieldFilter[0]?.value ? [...fieldFilter[0].value] : [];
        } else {
            currentValue = fieldFilter?.value ? [...fieldFilter.value] : [];
        }
        this.tempFilterSelections[fieldKey] = currentValue;
        const hasNull = currentValue.includes(null);
        const hasOtherValues = currentValue.some(v => v !== null);
        this.nullDisabledMap[fieldKey] = hasOtherValues && !hasNull;
    }

    applyPicklistFilter(field: Field, multiSelectRef?: MultiSelect, clearField?: boolean) {
        const fieldKey = field.canonical_name;
        const value = clearField ? [] : this.tempFilterSelections[fieldKey];
        if (clearField) {
            this.tempFilterSelections[fieldKey] = [];
        }
        this.onColumnFilter(value, field); // Use your existing logic
        if (multiSelectRef && typeof multiSelectRef.hide === 'function') {
            multiSelectRef.hide();
        }
    }

    onTempPicklistChange(selectedValues: any[], field: Field) {
        const fieldKey = field.canonical_name;
        const hasNull = selectedValues.includes(null);
        const hasOtherValues = selectedValues.some(v => v !== null);
        if (hasNull && hasOtherValues) {
            this.tempFilterSelections[fieldKey] = selectedValues.filter(v => v !== null);
            this.nullDisabledMap[fieldKey] = true;
            this.store.dispatch(new layoutActions.InfoAction({
                message: `You can filter by NULL or a value. You cannot select NULL with other options.`
            }));
        } else {
            this.nullDisabledMap[fieldKey] = hasOtherValues && !hasNull;
        }
    }

    cancelPicklistFilter(field: Field, multiSelectRef?: MultiSelect) {
        const fieldKey = field?.canonical_name;
        const fieldFilter = this.turboTable?.filters?.[fieldKey];
        const originalValue = Array.isArray(fieldFilter)
            ? fieldFilter[0]?.value || []
            : fieldFilter?.value || [];
        this.tempFilterSelections[fieldKey] = [...originalValue];
        if (multiSelectRef && typeof multiSelectRef.hide === 'function') {
            multiSelectRef.hide();
        }
    }

    checkNullFilter(filters: any, isMasterCheckbox: boolean = false): boolean {
        if (!filters || Object.keys(filters).length === 0) {
            this.nullDisabledMap = {};
            this.colFilterValues = filters;
            return true;
        }

        for (const filterKey in filters) {
            if (!filters.hasOwnProperty(filterKey)) continue;

            const value = filters[filterKey]?.value;
            if (!Array.isArray(value)) continue;

            const hasNull = value.includes(null);
            const hasOtherValues = value.some(v => v !== null);

            if (isMasterCheckbox && hasNull) {
                filters[filterKey].value = value.filter(v => v !== null);
                this.nullDisabledMap[filterKey] = hasOtherValues;
                this.store.dispatch(new layoutActions.InfoAction({
                    message: `You can filter by NULL or a value. You cannot select NULL with other options.`
                }));
                continue;
            }

            if (hasNull && hasOtherValues) {
                filters[filterKey].value = [null];
                this.nullDisabledMap[filterKey] = false;
                this.store.dispatch(new layoutActions.InfoAction({
                    message: `You can filter by NULL or a value. You cannot select NULL with other options.`
                }));
                continue;
            }

            this.nullDisabledMap[filterKey] = hasOtherValues && !hasNull;
        }

        this.colFilterValues = filters;
        return true;
    }

    onFilterGlobal(value: string, search = false) {
        // If the global search is completely removed, it will trigger a clear of the global filter
        if (value === '') {
            search = true;
        }

        this.filterText = value;
        if (search) {
            this.turboTable.restoringFilter = false;
            this.turboTable.first = 0;
            this.filterTableColumns.emit({ type: this.indexType, filters: { global: { value: value.trim() } } });
            this.turboTable.filterGlobal(value ? String(value).trim() : '', 'contains');
        }
    }

    onListAssetsAndFilters() {
        if (this.isFranchiseTable || this.isDivisionTable || this.isTransactionTable) {
            this.listAssetsAndFilters.emit({ listType: this.indexType });
        } else {
            this.listAssetsAndFilters.emit();
        }
    }

    /**
     * Reset a column filter to its default value
     */
    removeColumnFilter(field: Field) {
        if (field.type === this.fieldTypes.PICKLIST.type || field.type === this.fieldTypes.MULTI_PICKLIST.type || field.type === this.fieldTypes.CURRENCY.type || field.type === this.fieldTypes.NUMBER.type || field.type === this.fieldTypes.DATE.type) {
            this.onColumnFilter([], field);
        } else if (field.canonical_name !== 'photos') {
            this.onColumnFilter('', field);
        }
    }

    matchAssets(transaction) {
        this.router.navigate(['./match-assets', { transactions: [transaction.id], selectedProjectIdsList: this.selectedProjectIdsList }], { relativeTo: this.route });
    }

    matchForReview(transaction) {
        this.router.navigate(['./match-review', { transactions: [transaction.id] }], { relativeTo: this.route });
    }

    splitAssets(event) {
        const transaction: Transaction = event.data;
        this.router.navigate(['./split-assets', transaction.id], { relativeTo: this.route });
    }

    selectAll() {
        if (this.isTransactionTable) {
            const currentTransactions = this.getShowingTransactions();
            this.selectedTransactions = new Set(currentTransactions.map(t => t.id));
        } else if (this.isDivisionTable || this.isEventTable || this.isDivisionGroupTable || this.isFranchiseGroupTable || this.isRequestTable || this.isStudioTable || this.isStudioGroupTable || this.isStudioSubGroupTable || this.isDivisionSubGroupTable || this.isFranchiseSubGroupTable) {
            const currentAssets = this.getShowingAssets();
            this.selectedAssets = new Set(currentAssets.map(t => t.id));
            this.updateSelectedAssetsForParentComponent();
        } else {
            let franchiseCurrentAssets: Asset[];
            if (this.assetTypesShown === AssetTypes.Historical) {
                franchiseCurrentAssets = this.getShowingAssets();
            } else {
                franchiseCurrentAssets = this.getShowingAssets().filter(a => !a.division_id);
            }
            this.selectedAssets = new Set(franchiseCurrentAssets.map(t => t.id));
            this.updateSelectedAssetsForParentComponent();
        }

        const numOfPages = Math.ceil((this.isTransactionTable ? this.transactions.length : this.assets.length) / this.rowsPerPage);
        for (let i = 0; i < numOfPages; i++) {
            this.selectAllCheckedForPage[i * this.rowsPerPage] = true;
        }
    }
    /** Selects all assets/transactions in table or clears all selected assets/transactions */
    onSelectAll(selectAll: boolean) {
        this.isAllAssetsSelected = selectAll;
        this.isAllSelected.emit(selectAll);
        if (this.isAllAssetsSelected) {
            if (this.tableType === TableTypes.DivisionGroupTable || this.tableType === TableTypes.FranchiseGroupTable || this.tableType === TableTypes.FranchiseSubGroupTable || this.tableType === TableTypes.DivisionSubGroupTable || this.tableType === TableTypes.StudioGroupTable || this.tableType === TableTypes.StudioSubGroupTable || this.tableType === TableTypes.EventTable || (this.isFranchiseTable && this.indexType === AssetIndexTypes.ForReview) || (this.isDivisionTable && this.indexType === AssetIndexTypes.ForReview) || this.isTransactionMatchReviewTable || this.isTransactionMatchTable) {
                this.selectedAssets = new Set(this.getShowingAssets().map(a => a.id));
            } else if (this.tableType === TableTypes.TransactionTable) {
                this.lazyTransactions = this.transactions;
                this.selectedTransactions = new Set(this.getShowingTransactions().map(a => a.id));
            }
            if (this.tableType === TableTypes.TransactionTable) {
                this.selectedTransactions = new Set(this.getShowingTransactions().map(a => a.id));
            }
            this.turboTable.paginator = false;
            this.pageChanged.emit(null);
        } else {
            this.turboTable.paginator = true;
            this.paginatorTopDomLoop = 0;
            this.clearAllSelectedAssets();
            this.clearAllSelectedTransactions();
            this.turboTable.first = 0;
            this.turboTable.rows = this.rowsPerPage;
            this.lazyLoad({ first: this.turboTable.first, rows: this.turboTable.rows });
        }
    }

    /** Selects all assets on current page or clears all selected assets */
    onSelectAllPageAssets() {
        if (this.isTransactionTable) {
            const currentTransactions = this.getPageTransactions();
            if (this.selectAllCheckedForPage[this.turboTable.first]) {
                this.selectedTransactions = new Set(this.selectedTransactions);
                const newlySelectedTransactions = new Set(currentTransactions.map(t => t.id));
                newlySelectedTransactions.forEach(a => this.selectedTransactions.add(a));
                this.selectAllCheckedForPage[this.turboTable.first] = true;
            } else {
                this.clearAllSelectedTransactions();
            }
        } else if (this.isDivisionTable || this.isEventTable || this.isDivisionGroupTable || this.isFranchiseGroupTable || this.isRequestTable || this.isStudioTable || this.isStudioGroupTable || this.isStudioSubGroupTable || this.isFranchiseSubGroupTable || this.isDivisionSubGroupTable || this.isTransactionMatchReviewTable || this.isTransactionMatchTable) {
            const currentAssets = this.getPageAssets();
            if (this.selectAllCheckedForPage[this.turboTable.first]) {
                this.selectedAssets = new Set(this.selectedAssets);
                const newlySelectedAssets = new Set(currentAssets.map(t => t.id));
                newlySelectedAssets.forEach(a => this.selectedAssets.add(a));
                this.updateSelectedAssetsForParentComponent();
                this.selectAllCheckedForPage[this.turboTable.first] = true;
                if (this.isDivisionGroupTable || this.isDivisionSubGroupTable || this.isFranchiseGroupTable || this.isFranchiseSubGroupTable || this.isStudioGroupTable || this.isStudioSubGroupTable || this.isEventTable) {
                    this.onSelectAll(true);
                }
            } else {
                if ((this.isDivisionTable && this.indexType === AssetIndexTypes.ForReview) || this.isDivisionGroupTable || this.isDivisionSubGroupTable || this.isFranchiseGroupTable || this.isFranchiseSubGroupTable || this.isStudioGroupTable || this.isStudioSubGroupTable || this.isEventTable) {
                    this.onSelectAll(false);
                }
                this.clearAllSelectedAssets();
            }
        } else {
            let franchiseCurrentAssets: Asset[] = [];
            if (this.assetTypesShown === AssetTypes.Historical) {
                franchiseCurrentAssets = this.getPageAssets();
            } else {
                franchiseCurrentAssets = this.getPageAssets().filter(a => !a.division_id);
            }
            if (this.selectAllCheckedForPage[this.turboTable.first]) {
                this.selectedAssets = new Set(this.selectedAssets);
                const newlySelectedAssets = new Set(franchiseCurrentAssets.map(t => t.id));
                newlySelectedAssets.forEach(a => this.selectedAssets.add(a));
                this.updateSelectedAssetsForParentComponent();
                this.selectAllCheckedForPage[this.turboTable.first] = true;
            } else {
                if (this.indexType === AssetIndexTypes.ForReview) {
                    this.onSelectAll(false);
                }
                this.clearAllSelectedAssets();
            }
        }

        if ((this.isTransactionTable ? this.selectedTransactions.size : this.selectedAssets.size) === this.assetCountTotal) {
            this.isAllAssetsSelected = true;
        }
    }

    onSelectAllTransactions(selectAll: boolean) {
        this.isAllAssetsSelected = selectAll;
        if (this.isAllAssetsSelected) {
            const currentTransactions = this.getShowingTransactions();
            this.selectedTransactions = new Set(currentTransactions.map(t => t.id));
            const numOfPages = Math.ceil(this.transactions.length / this.rowsPerPage);
            for (let i = 0; i < numOfPages; i++) {
                this.selectAllCheckedForPage[i * this.rowsPerPage] = true;
            }
        } else {
            this.clearAllSelectedTransactions();
        }
    }

    resetFilters() {
        this.dateFiltersMin = {};
        this.dateFiltersMax = {};
        this.nullDisabledMap = {};
        this.filterTableColumns.emit({ type: this.indexType, reset: true });
    }

    clearAllSelectedAssets() {
        this.selectedAssets = new Set();
        this.updateSelectedAssetsForParentComponent();
        this.selectAllCheckedForPage = {};
        this.isAllAssetsSelected = false;
    }

    clearAllSelectedTransactions() {
        this.selectedTransactions = new Set();
        this.selectAllCheckedForPage = {};
        this.isAllAssetsSelected = false;
        this.expandedItems = {};
    }

    clearAllSelectedItems() {
        if (this.isTransactionTable) {
            this.clearAllSelectedTransactions();
        } else {
            this.clearAllSelectedAssets();
        }
    }

    onColReorder(event) {
        const fields = this.selectedFieldOptions.slice();
        if (event.dropIndex < event.dragIndex) {
            fields.splice(event.dropIndex, 0, this.selectedFieldOptions[event.dragIndex]);
            fields.splice(event.dragIndex + 1, 1);
        } else {
            fields.splice(event.dropIndex + 1, 0, this.selectedFieldOptions[event.dragIndex]);
            fields.splice(event.dragIndex, 1);
        }
        if (this.isTransactionTable) {
            this.store.dispatch(new fieldActions.SaveTransactionSelectedAction(fields));
        } else if (this.isDivisionTable) {
            this.store.dispatch(new fieldActions.SaveDivisionAssetSelectedAction(fields));
        } else if (this.isEventTable) {
            this.store.dispatch(new fieldActions.SaveEventAssetSelectedAction(fields));
        } else if (this.isFranchiseTable) {
            this.store.dispatch(new fieldActions.SaveAssetSelectedAction(fields));
        } else if (this.isFranchiseGroupTable) {
            this.store.dispatch(new fieldActions.SaveFranchiseGroupAssetSelectedAction(fields));
        } else if (this.isDivisionGroupTable) {
            this.store.dispatch(new fieldActions.SaveDivisionGroupAssetSelectedAction(fields));
        } else if (this.isRequestTable) {
            this.store.dispatch(new fieldActions.SaveRequestAssetSelectedAction(fields));
        } else if (this.isStudioTable) {
            this.store.dispatch(new fieldActions.SaveStudioSelectedAction(fields));
        } else if (this.isStudioGroupTable) {
            this.store.dispatch(new fieldActions.SaveStudioGroupAssetSelectedAction(fields));
        } else if (this.isStudioSubGroupTable) {
            this.store.dispatch(new fieldActions.SaveStudioSubGroupAssetSelectedAction(fields));
        } else if (this.isFranchiseSubGroupTable) {
            this.store.dispatch(new fieldActions.SaveFranchiseSubGroupAssetSelectedAction(fields));
        } else if (this.isDivisionSubGroupTable) {
            this.store.dispatch(new fieldActions.SaveDivisionSubGroupAssetSelectedAction(fields));
        }
    }

    goToAssetView(asset: Asset) {
        if (this.isStudioTable) {
            this.router.navigate(['studio', this.currentStudioId, 'assets', asset.id, { studio: 'assets' }]);
        } else if (this.isDivisionTable) {
            this.router.navigate(['studio', this.currentStudioId, 'assets', asset.id, { division: 'assets' }]);
        } else if (this.isEventTable) {
            if (!asset.division_id && !this.user.permission.isFranchiseUser(asset.franchise_id, asset.studio_id)) {
                this.store.dispatch(new layoutActions.ErrorAction({
                    error: new HttpErrorResponse({ error: new Error('You do not have access to the feature this asset belongs to.') })
                }));
                return;
            }
            this.router.navigate(['studio', this.division.studio_id, 'assets', asset.id, { division: 'assets', event_id: this.event.id }]);
        } else if (this.isFranchiseGroupTable) {
            this.router.navigate(['studio', this.currentStudioId, 'assets', asset.id, { franchise: 'assets', group_id: this.group.id }]);
        } else if (this.isDivisionGroupTable) {
            this.router.navigate(['studio', this.currentStudioId, 'assets', asset.id, { division: 'assets', group_id: this.group.id }]);
        } else if (this.isRequestTable) {
            this.router.navigate(['studio', this.currentStudioId, 'assets', asset.id, { franchise: 'assets', request_id: this.request.id }]);
        } else if (this.isStudioGroupTable) {
            if (asset.division_id) {
                this.router.navigate(['studio', this.currentStudioId, 'assets', asset.id, { division: 'assets' }]);
            } else {
                this.router.navigate(['studio', this.currentStudioId, 'assets', asset.id, { franchise: 'assets' }]);
            }
        } else if (this.isFranchiseSubGroupTable) {
            this.router.navigate(['studio', this.currentStudioId, 'assets', asset.id, { franchise: 'assets', sub_group_id: this.subGroup.id }]);
        } else if (this.isDivisionSubGroupTable) {
            this.router.navigate(['studio', this.currentStudioId, 'assets', asset.id, { division: 'assets', sub_group_id: this.subGroup.id }]);
        } else if (this.isStudioSubGroupTable) {
            if (asset.division_id) {
                this.router.navigate(['studio', this.currentStudioId, 'assets', asset.id, { division: 'assets' }]);
            } else {
                this.router.navigate(['studio', this.currentStudioId, 'assets', asset.id, { franchise: 'assets' }]);
            }
        } else {
            this.router.navigate(['studio', this.currentStudioId, 'assets', asset.id, { franchise: 'assets' }]);
        }
    }

    onSelectRowCheckbox(asset) {

        if (this.isTransactionTable) {
            if (this.selectedTransactions.has(asset.id)) {
                this.selectedTransactions.delete(asset.id);
                this.selectedTransactions = new Set(this.selectedTransactions);
                this.selectAllCheckedForPage[this.turboTable.first] = false;
                this.isAllAssetsSelected = false;
            } else {
                this.selectedTransactions.add(asset.id);
                this.selectedTransactions = new Set(this.selectedTransactions);
                const currentTransactions = this.getPageTransactions();
                let selectAll = true;
                currentTransactions.forEach(a => {
                    if (!this.selectedTransactions.has(a.id)) {
                        selectAll = false;
                    }
                });
                this.selectAllCheckedForPage[this.turboTable.first] = selectAll;
                if (this.selectedTransactions.size === this.assetCountTotal) {
                    this.isAllAssetsSelected = true;
                }
            }
        } else {
            if (this.selectedAssets.has(asset.id)) {
                this.selectedAssets.delete(asset.id);
                this.showCharSet = this.showCharSet.filter(val => val.id !== asset.id)
                this.selectedAssets = new Set(this.selectedAssets);
                this.selectAllCheckedForPage[this.turboTable.first] = false;
                this.isAllAssetsSelected = false;
            } else {
                this.selectedAssets.add(asset.id);
                this.selectedAssets = new Set(this.selectedAssets);
                let currentAssets: Asset[] = [];
                let selectAll = true;
                if (asset.franchise_id !== null) {
                    this.showCharSet.push(asset);
                }

                if (this.isFranchiseTable) {
                    currentAssets = this.getPageAssets().filter(a => !a.division_id);
                } else {
                    currentAssets = this.getPageAssets();
                }

                currentAssets.forEach(a => {
                    if (!this.selectedAssets.has(a.id)) {
                        selectAll = false;
                    }
                });

                this.selectAllCheckedForPage[this.turboTable.first] = selectAll;
                if (this.selectedAssets.size === this.assetCountTotal) {
                    this.isAllAssetsSelected = true;
                }
            }
            this.updateSelectedAssetsForParentComponent();
            // Condition for Available Char/Set only for Franchise Assets at Division Index
            if (this.isDivisionTable) {
                this.updateCharSetOptions = this.showCharSet.length > 0 ? true : false;
                this.addCharSetOptions()
            }
        }
    }

    updateSelectedAssetsForParentComponent() {
        if (this.isRequestTable || this.isTransactionMatchTable || this.isTransactionMatchReviewTable) {
            this.setSelectedAssets.emit(this.selectedAssets);
        }
    }

    updateTransactions(transactions) {
        const transactionData: Transaction[] = [];
        transactions.forEach((t) => transactionData.push(new Transaction({ ...t })));
        this.store.dispatch(new transactionActions.UpdateMultipleAction({ franchiseId: this.franchise.id, transactions: transactionData }));
    }

    showPaginator(assets) {
        return assets && assets.length && assets.length > this.rowsPerPage;
    }

    rowTrackBy(_index: number, row: any) {
        if (row) {
            return row.id;
        }
    }

    removeFromTable() {
        const assetIds: number[] = this.getShowingAssetIds().filter(assetId => this.selectedAssets.has(assetId));
        if (assetIds) {
            let data: ConfirmModalData;
            if (this.isEventTable) {
                data = {
                    onConfirm: this.removeFromTableOnConfirm.bind(this),
                    title: `Remove Assets from Event ${this.event.name}`,
                    message: 'Are you sure you want to remove these assets from this event?',
                    confirmButton: 'Confirm',
                };
            } else {
                data = {
                    onConfirm: this.removeFromTableOnConfirm.bind(this),
                    title: `Remove Assets from Request #${this.request.studio_generated_id}`,
                    message: 'Are you sure you want to remove these assets from this request?',
                    confirmButton: 'Confirm',
                };
            }
            this.dialog.open(ConfirmModalComponent, { data });
        }
    }

    removeFromTableOnConfirm(dialogRef) {
        const assetIds: number[] = this.getShowingAssetIds().filter(assetId => this.selectedAssets.has(assetId));
        if (this.isEventTable) {
            this.store.dispatch(new eventActions.RemoveAssetsAction({ assetIds, eventId: this.event.id }));
        } else {
            this.store.dispatch(new requestAssetActions.DeleteAction({ request_id: this.request.id, assetIds }));
        }
        dialogRef.componentInstance.saveDisabled = true;

        this.store.select(fromRoot.getAssetSaving).pipe(
            filter(loading => loading !== ActionStatus.Loading),
            take(1))
            .subscribe((loading) => {
                if (loading === ActionStatus.Complete) {
                    dialogRef.close(true);
                    this.clearAllSelectedAssets();
                } else {
                    dialogRef.componentInstance.saveDisabled = false;
                }
            });
    }

    clearDate(datepicker: MatDatepicker<Date>, values: string[], field: Field) {
        datepicker.select(undefined);
        this.onColumnFilter(values, field);
    }

    exportCSV() {
        this.dialog.open(ConfirmModalComponent, {
            data: {
                onConfirm: this.confirmExportCSV.bind(this),
                message: `Generate CSV report for ${this.selectedTransactions.size || this.selectedAssets.size} selected ${(this.isTransactionTable) ? 'Transactions' : 'Assets'}?`,
                confirmButton: 'Confirm',
            }
        });
    }

    confirmExportCSV(dialogRef) {
        dialogRef.componentInstance.saveDisabled = true;
        dialogRef.close(true);
        const fields = this.selectedFields.filter(field => field.canonical_name !== 'photos');
        if (this.isTransactionTable) {
            const transactions = this.getShowingTransactions().filter((trans) => this.selectedTransactions.has(trans.id));
            this.projectCurrencies$.pipe(take(1)).subscribe(projectCurrencies => {
                const selectedCurrency = projectCurrencies.find(currency => currency.id === this.selectedProjectCurrencyId);
                this.exportToCSVService(fields, transactions, 'transactions', selectedCurrency);
            });
        } else {
            const assets = this.getShowingAssets().filter(asset => this.selectedAssets.has(asset.id));
            if (this.isFranchiseTable) {
                if (this.selectedProjectIdsList.length === 0 || this.selectedProjectIdsList.length > 1) {
                    const otherCostIndex = fields.findIndex(field => field.canonical_name === 'other_cost');
                    if (otherCostIndex > -1) {
                        fields.splice(otherCostIndex, 1);
                    }
                }
                this.projectCurrencies$.pipe(take(1)).subscribe(projectCurrencies => {
                    const selectedCurrency = projectCurrencies.find(currency => currency.id === this.selectedProjectCurrencyId);
                    this.exportToCSVService(fields, assets, 'assets', selectedCurrency);
                });
            } else if (this.isRequestTable) {
                // Add request specific columns
                this.addRequestSpecificColumns(fields);
                this.exportToCSVService(fields, assets, 'assets');
            } else if (this.isEventTable) {
                // Add Event specific columns
                this.addEventSpecificColumns(fields);
                this.exportToCSVService(fields, assets, 'assets', null, this.assetEventForAssetIds);
            } else {
                this.exportToCSVService(fields, assets, 'assets');
            }
        }
    }

    /** Add Event Columns for exporting csv and pdf reports
     * @param fields (Field | string) []
     * @param isFieldsType specifies if fields is Field or string type
     */
    addEventSpecificColumns(fields, isFieldsFieldType = true) {
        // Add event specific columns
        isFieldsFieldType ? fields.push(new Field({ name: 'Qty. on Loan' })) : fields.push('Qty. on Loan');
        isFieldsFieldType ? fields.push(new Field({ name: 'Qty. Returned' })) : fields.push('Qty. Returned');
    }

    /** Add Request Columns for exporting csv and pdf reports
     * @param fields (Field | string) []
     * @param isFieldsType specifies if fields is Field or string type
     */
    addRequestSpecificColumns(fields, isFieldsFieldType = true) {
        // Add request specific columns
        if (this.isRequestConflictColumnVisible()) {
            isFieldsFieldType ? fields.push(new Field({ name: 'Multiple Requests' })) : fields.push('Multiple Requests');
        }
        if (this.isRequestStatusColumnVisible()) {
            isFieldsFieldType ? fields.push(new Field({ name: 'Request Status' })) : fields.push('Request Status');
        }
        if (this.isRequestSentToColumnVisible()) {
            isFieldsFieldType ? fields.push(new Field({ name: 'Sent To' })) : fields.push('Sent To');
        }
    }

    getPageAssets() {
        if ((this.turboTable.first === 0 || this.turboTable.first) && this.rowsPerPage)
            return this.assets.slice(this.turboTable.first, this.turboTable.first + this.rowsPerPage);
        return this.assets;
    }

    getShowingAssets() {
        return this.assets?.filter(a => a !== null && a !== undefined) || [];
    }

    getPageTransactions() {
        if ((this.turboTable.first === 0 || this.turboTable.first) && this.rowsPerPage)
            return this.transactions.slice(this.turboTable.first, this.turboTable.first + this.rowsPerPage);
        return this.transactions;
    }

    // Only gets the transactions that are VISIBLE in the table these results are filtered by the global filter
    getShowingTransactions() {
        return this.transactions;
    }

    barcodeSearch() {
        const dialogRef = this.dialog.open(BarcodeModalComponent, { panelClass: 'scannerOverlay' });
        dialogRef.afterClosed().pipe(take(1)).subscribe(result => {
            if (result) {
                const foundAssets = this.assets.filter((asset) => asset.barcode === result);
                if (foundAssets.length === 1) {
                    this.goToAssetView(foundAssets[0]);
                } else {
                    let barcodeField = this.selectedFields.find((field) => field.type === FIELD_TYPES.BARCODE.type);
                    if (!barcodeField) {
                        barcodeField = this.fields.find((field) => field.type === FIELD_TYPES.BARCODE.type);
                        if (barcodeField) {
                            this.selectedFields.push(barcodeField);
                        }
                    }
                    this.filterText = result;
                    this.turboTable.filterGlobal(result, 'contains');
                }
            }
        });
    }

    /**
     * With lazy load enabled, we must manually pass a page of "lazyAssets" to the table, rather than all assets at once
     * @param {Object} event - Object with index of the first row, and number of rows per page
     */
    lazyLoad(event: { first: number, rows: number }) {
        if (this.assets) {
            this.lazyAssets = this.assets.slice(event.first, event.first + event.rows).filter(a => a != null);

            const alreadyInitiated = this.loadInitiatedMap[`${this.stateKey}-${event.first}-${event.rows}`];

            let pageSizeChanged = false;
            const tableState = JSON.parse(localStorage.getItem(this.stateKey) ?? 'null');
            if (tableState) {
                if (event.rows != tableState.rows) {
                    pageSizeChanged = true;
                }
            }

            const isActiveView = this.currentView === this.indexType;
            const shouldLoad = this.lazyAssets.length == 0 || !alreadyInitiated || pageSizeChanged;

            if (shouldLoad && (this.indexType !== AssetIndexTypes.ForReview || isActiveView)) {
                const recordIndex = event.first;
                let pageSize = this.rowsPerPage;

                if (event.rows) {
                    pageSize = event.rows;
                } else {
                    pageSize = this.defaultRowsPerPage();
                }

                const pageEvent = {
                    recordIndex: recordIndex,
                    pageSize: pageSize
                }
                this.pageChanged.emit(pageEvent);
                this.loadInitiatedMap[`${this.stateKey}-${event.first}-${event.rows}`] = true;
            }
        }
        if (this.transactions.length > 0) {
            this.lazyTransactions = this.transactions.slice(event.first, event.first + event.rows).filter(a => a != null);
        }
        if (this.rowsPerPage !== event.rows) {
            this.assets && this.assets.length ? this.clearAllSelectedAssets() : this.clearAllSelectedTransactions();
        }
        if (event.rows)
            this.rowsPerPage = event.rows;
    }

    buildShowingDropDown() {
        this.assetToggleOptions = [];

        const isStudioAdmin = this.user.isStudioAdmin(this.currentStudioId);
        const seriesOrFranchiseCustomName = this.franchise && this.franchise.is_series ? this.customFieldNames.series_id : this.customFieldNames.franchise_id;
        const franchiseNameOrCustomName = this.franchise ? this.franchise.name : seriesOrFranchiseCustomName;
        const divisionNameOrCustomName = this.franchise ? this.customFieldNames.division_id : this.division?.name
        const franchiseOwnedSubLabel = `Display assets currently owned by this ${seriesOrFranchiseCustomName}`;
        const divisionOwnedSubLabel = this.franchise ? `Display assets assigned to this ${seriesOrFranchiseCustomName} and owned by a ${this.customFieldNames.division_id}` : `Display assets currently owned by this ${this.customFieldNames.division_id}`;
        const allAssetsSubLabel = `Displays all assets`;
        const historicalSubLabel = `Display Assets previously and currently in this ${this.franchise ? seriesOrFranchiseCustomName : this.customFieldNames.division_id}`;

        const franchiseOwnedOption = { label: `${franchiseNameOrCustomName} Owned Assets`, value: AssetTypes.Franchise, subLabel: franchiseOwnedSubLabel };
        const divisionOwnedOption = { label: `${divisionNameOrCustomName} Owned Assets`, value: AssetTypes.Division, subLabel: divisionOwnedSubLabel };
        const allAssetsOption = { label: `${franchiseNameOrCustomName} and ${this.customFieldNames.division_id} Owned Assets`, value: AssetTypes.All, subLabel: allAssetsSubLabel, disabled: false };
        const studioGroupsOption = { label: 'Everything', value: AssetTypes.All, subLabel: allAssetsSubLabel, disabled: true };
        const historicalOption = { label: `Historical ${this.franchise ? franchiseNameOrCustomName : divisionNameOrCustomName} Assets`, value: AssetTypes.Historical, subLabel: historicalSubLabel };

        if (this.tableType === TableTypes.FranchiseTable) {
            allAssetsOption.subLabel += ` currently assigned to this ${seriesOrFranchiseCustomName}`;
            if (isStudioAdmin) {
                this.assetToggleOptions.push(franchiseOwnedOption, divisionOwnedOption, allAssetsOption, historicalOption);
            } else if (this.user.permission.canViewHistorical(this.franchise.id, this.currentStudioId)) {
                this.assetToggleOptions.push(franchiseOwnedOption, historicalOption);
            }
        } else if (this.tableType === TableTypes.DivisionTable) {
            if (isStudioAdmin || this.user.permission.canViiewHistoricalDivision(this.division.id, this.currentStudioId)) {
                this.assetToggleOptions.push(divisionOwnedOption, historicalOption);
            }
        } else if (isStudioAdmin && (this.tableType === TableTypes.DivisionGroupTable || this.tableType === TableTypes.FranchiseGroupTable || this.tableType === TableTypes.StudioGroupTable || this.tableType === TableTypes.DivisionSubGroupTable || this.tableType === TableTypes.FranchiseSubGroupTable || this.tableType === TableTypes.StudioSubGroupTable)) {
            allAssetsOption.label = 'Everything';
            if (this.tableType === TableTypes.FranchiseGroupTable || this.tableType === TableTypes.FranchiseSubGroupTable) {
                this.assetToggleOptions.push(franchiseOwnedOption, allAssetsOption);
            } else if (this.tableType === TableTypes.DivisionGroupTable || this.tableType === TableTypes.DivisionSubGroupTable) {
                this.assetToggleOptions.push(divisionOwnedOption, allAssetsOption);
            } else {
                this.assetToggleOptions.push(studioGroupsOption);
            }
        }
    }

    updateBulkOptions(assetsToShow?) {
        if (this.tableType === TableTypes.FranchiseTable) {
            if (this.indexType === AssetIndexTypes.ForReview) {
                this.acceptBulkOption.disabled = false;
                this.exportOptions = [this.exportCSVOption];
                this.addUpdateOptions = [this.updateDispositionOption, this.updateDepartmentOption, this.updateCustomFieldOption, this.addGroupsOption, this.acceptBulkOption, this.addPhotosOption, this.bulkTrashOption];
                this.eventOptions = [];
                this.moveOptionVisible = true;
                this.requestOptionVisible = true;
            } else if (this.indexType === AssetIndexTypes.Default) {
                this.exportOptions = this.fullExportOptions;
                this.addUpdateOptions = [this.updateDispositionOption, this.updateDepartmentOption, this.updateCustomFieldOption, this.addGroupsOption, this.addPhotosOption, this.bulkTrashOption, this.addAttachmentOption];
                this.eventOptions = [];
                this.moveOptionVisible = true;
                this.mergeOptionVisible = true;
            }
        } else if (this.tableType === TableTypes.TransactionTable) {
            this.exportOptions = [this.exportCSVOption];
            const updateDisposition = this.indexType === AssetIndexTypes.Excluded ? this.updateExcludedDispositionOption : this.updateDispositionOption
            this.addUpdateOptions = [updateDisposition, this.updateDepartmentOption, this.toggleExcludedBulkOption];
            this.eventOptions = [];
            this.moveOptionVisible = false;
            this.requestOptionVisible = false;
            this.mergeOptionVisible = false;
        } else if (this.tableType === TableTypes.DivisionTable) {
            if (this.indexType === AssetIndexTypes.ForReview) {
                this.acceptBulkOption.disabled = false;
                this.moveOptionVisible = true;
                this.exportOptions = [this.exportCSVOption];
                this.addUpdateOptions = [this.updateStatusOption, this.updateDepartmentOption, this.updateFranchiseInfoOption, this.updateCustomFieldOption, this.addGroupsOption, this.acceptBulkOption, this.addPhotosOption, this.bulkTrashOption]
            } else {
                this.exportOptions = this.fullExportOptions;
                this.addUpdateOptions = [this.updateStatusOption, this.updateDepartmentOption, this.updateFranchiseInfoOption, this.updateCustomFieldOption, this.addGroupsOption, this.addPhotosOption, this.bulkTrashOption, this.addAttachmentOption];
                this.eventOptions = [];
                this.moveOptionVisible = true;
                this.requestOptionVisible = false;
                this.mergeOptionVisible = true;
                if (this.division.events_enabled) {
                    this.addUpdateOptions.unshift(this.addToEventOption);
                }
                if (this.isDispositionVisible && this.canEdit) {
                    this.addUpdateOptions.splice(2, 0, this.updateDispositionOption)
                }
            }
        } else if (this.tableType === TableTypes.EventTable) {
            this.exportOptions = this.fullExportOptions;
            this.addUpdateOptions = [this.updateStatusOption, this.updateDepartmentOption, this.updateCustomFieldOption, this.addGroupsOption, this.addPhotosOption];
            this.eventOptions = [this.checkOutOption, this.checkInOption, this.transferToEventOption, this.removeFromEventOption];
            this.moveOptionVisible = true;
            this.requestOptionVisible = false;
            this.mergeOptionVisible = false;
            if (this.division.events_enabled) {
                this.eventOptions.unshift(this.copyToEventOption);
            }
        } else if (this.tableType === TableTypes.DivisionGroupTable) {
            if (assetsToShow === AssetTypes.All) {
                this.exportOptions = this.fullExportOptions;
                this.addUpdateOptions = [];
                this.moveOptionVisible = true;
                this.requestOptionVisible = false;
                this.mergeOptionVisible = false;
            } else {
                this.exportOptions = this.fullExportOptions;
                this.addUpdateOptions = [this.updateStatusOption, this.updateDepartmentOption, this.updateFranchiseInfoOption, this.updateCustomFieldOption, this.addGroupsOption, this.removeAssetsFromGroup, this.addPhotosOption];
                this.moveOptionVisible = true;
                this.requestOptionVisible = false;
                this.mergeOptionVisible = true;
            }
        } else if (this.tableType === TableTypes.FranchiseGroupTable) {
            if (assetsToShow === AssetTypes.All) {
                this.exportOptions = this.fullExportOptions;
                this.addUpdateOptions = [];
                this.moveOptionVisible = true;
                this.requestOptionVisible = false;
                this.mergeOptionVisible = false;
            } else {
                this.exportOptions = this.fullExportOptions;
                this.addUpdateOptions = [this.updateDispositionOption, this.updateDepartmentOption, this.updateCustomFieldOption, this.addGroupsOption, this.removeAssetsFromGroup, this.addPhotosOption];
                this.moveOptionVisible = true;
                this.requestOptionVisible = false;
                this.mergeOptionVisible = true;
            }
        } else if (this.tableType === TableTypes.RequestTable) {
            this.exportOptions = this.fullExportOptions;
            this.addUpdateOptions = [this.updateDispositionOption, this.updateDepartmentOption, this.updateCustomFieldOption, this.addGroupsOption, this.addPhotosOption];
            this.moveOptionVisible = true;
            this.requestOptionVisible = false;
            this.mergeOptionVisible = false;
            if (this.requestType === RequestTypes.Requester && this.request.status === RequestStatus.Unsent) {
                this.addUpdateOptions.push(this.removeFromRequestOption);
            }
        } else if (this.tableType === TableTypes.StudioTable) {
            this.exportOptions = this.fullExportOptions;
            this.addUpdateOptions = [this.addGroupsOption, this.updateDispositionOption];
            this.moveOptionVisible = true;
            this.requestOptionVisible = false;
            this.mergeOptionVisible = false;
        } else if (this.tableType === TableTypes.StudioGroupTable || this.tableType === TableTypes.StudioSubGroupTable) {
            this.exportOptions = this.fullExportOptions;
            this.addUpdateOptions = [];
            this.moveOptionVisible = true;
            this.requestOptionVisible = false;
            this.mergeOptionVisible = false;
        } else if (this.tableType === TableTypes.DivisionSubGroupTable) {
            if (assetsToShow === AssetTypes.All) {
                this.exportOptions = this.fullExportOptions;
                this.addUpdateOptions = [];
                this.moveOptionVisible = true;
                this.requestOptionVisible = false;
                this.mergeOptionVisible = false;
            } else {
                this.exportOptions = this.fullExportOptions;
                this.addUpdateOptions = [this.updateStatusOption, this.updateDepartmentOption, this.updateFranchiseInfoOption, this.updateCustomFieldOption, this.addGroupsOption, this.removeAssetsFromSubGroup, this.addPhotosOption];
                this.moveOptionVisible = true;
                this.requestOptionVisible = false;
                this.mergeOptionVisible = true;
            }
        } else if (this.tableType === TableTypes.FranchiseSubGroupTable) {
            if (assetsToShow === AssetTypes.All) {
                this.exportOptions = this.fullExportOptions;
                this.addUpdateOptions = [];
                this.moveOptionVisible = true;
                this.requestOptionVisible = false;
                this.mergeOptionVisible = false;
            } else {
                this.exportOptions = this.fullExportOptions;
                this.addUpdateOptions = [this.updateDispositionOption, this.updateDepartmentOption, this.updateCustomFieldOption, this.addGroupsOption, this.removeAssetsFromSubGroup, this.addPhotosOption];
                this.moveOptionVisible = true;
                this.requestOptionVisible = false;
                this.mergeOptionVisible = true;
            }
        }
    }

    onAssetLimit() {
        const data = { limit: this.assetLimit, total: this.assetCountTotal };
        this.dialog.open(AssetLimitModalComponent, { data }).afterClosed().pipe(take(1)).subscribe(data => {
            if (data && data.limit && data.limit !== this.assetLimit) {
                this.store.dispatch(new assetActions.SetAssetLimit(data.limit));
            }
        });
    }

    private setupSubscriptions() {
        if (this.subs) {
            throw new Error('Subscriptions already setup');
        }
        this.subs = new Subscription();

        const layoutBreakpointSub = this.breakpointObserver.observe([Breakpoints.XSmall]).subscribe(result => {
            this.responsive = result.matches ? true : false;
            if (result.matches && this.selectedFieldOptions && this.selectedFields) {
                this.changeColumnFieldsForMobile();
            }
        });

        const approvalsEnabledSub = this.store.select(fromRoot.getStudioApprovalsEnabled).subscribe(approvalsEnabled => {
            this.approvalsEnabled = approvalsEnabled;
            if (this.isFranchiseTable || this.isDivisionTable || this.isEventTable) {
                this.addRequestOption();
            }
        });

        let isLoadingSub;
        if (this.isTransactionTable) {
            isLoadingSub = this.store.select(fromRoot.getTransactionLoading).subscribe(loading => {
                this.isLoading = loading === ActionStatus.Complete ? false : true;
            });
        } else {
            isLoadingSub = this.store.select(fromRoot.getAssetLoading).subscribe(loading => {
                this.isLoading = loading === ActionStatus.Complete ? false : true;
            });
        }

        const getFieldEntitiesSub = this.store.select(fieldSelectors.getFieldEntitiesWithAllFakeColumns).pipe(
            filter(f => !!f))
            .subscribe(fieldEntities => {
                fieldEntities = { ...fieldEntities, [FAKE_STORAGE_BOX_BARCODE_FIELD[0].id]: new Field(FAKE_STORAGE_BOX_BARCODE_FIELD[0]) }
                this.fieldEntities = fieldEntities;
            });

        const assetLimitSub = this.store.select(fromRoot.getAssetLimit).subscribe(assetLimit => {
            this.assetLimit = assetLimit;
        });

        this.subs
            .add(layoutBreakpointSub)
            .add(approvalsEnabledSub)
            .add(isLoadingSub)
            .add(getFieldEntitiesSub)
            .add(assetLimitSub);
    }

    private moveColumnField(canonicalName: string) {
        const field = this.selectedFields.find(f => f.canonical_name === canonicalName);
        if (field) {
            const index = this.selectedFields.findIndex(f => f.canonical_name === field.canonical_name);
            if (index > -1) {
                this.selectedFields.splice(index, 1);
                this.selectedFields.unshift(field);
            }
        }
    }

    private getShowingAssetIds() {
        return this.getShowingAssets().map(asset => asset.id);
    }

    defaultRowsPerPage() {
        return this.responsive ? 10 : 50;
    }

    /** WARNING: Setting columnWidths to '60' (this does result in the first column's width getting set to 60 but it needs to be set to a positive integer of something wide enough) and restoring the state and column widths is a very hacky solution to the problem (AH-1343) where the tableState stored column widths and would add new columns at width = 0. This resets the column widths and forces new columns to show up */
    private saveTableState(tableState) {
        tableState.columnWidths = '60'; // Part of the AH-1343 solution

        this.localStorageService.updateSettings(this.stateKey, JSON.stringify(tableState));

        this.turboTable.restoreState(); // Part of the AH-1343 solution
        this.turboTable.restoreColumnWidths(); // Part of the AH-1343 solution
    }

    expotAllCSV() {
        this.exportAllCsvEvent.emit()
    }
}
